import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import VueAxios from 'vue-axios';
import moment from 'moment';

import * as Functions from './utils/functions';
import { COVERAGES, STATUS } from './utils/constants';
import router from './router';
// already imported ✅ — just add trackWhatConvertsLead to the import

import { trackWhatConvertsLead } from './utils/functions';


Vue.use(Vuex);
Vue.use(VueAxios, axios);


const homeInspectorModule = {
  namespaced: true,
  state: {
    quote: {
      // Personal
      // #1

      fullLegalNameOfApplicant: '',
      nameOfPrincipalHomeInspector: '',
      // #2
      customer: {
        actContactId: '',
        address: '',
        email: '',
        state: '',
        city: '',
        zipCode: '',
        contactName: '',
        companyName: '',
        phone: '',
        isHomeInspector: '',
        appStatus: 1,
        partnerName: '',
      },
      website: '',
      yearOfBusinessEstablishment: undefined,
      // #3
      isFranchisee: undefined,
      fullLegalNameOfFranchisor: '',

      // Pricipal's/Applicant's Experience and Training
      // #4
      homeInspectingExperience: undefined,
      relatedIndustryExperience: undefined,
      // #5
      licensedInWorkingStates: undefined,
      requirementsLicensedInWorkingStates: undefined,
      // #6
      applicantTraining: undefined,
      applicantTrainingOtherDetails: '',

      // Financial
      // #7
      numberOfResidentialInspectionsInThisYear: 0,
      revenueFromResidentialInspectionsInThisYear: 0,
      numberOfResidentialInspectionsExpectedInNextYear: 0,
      revenueFromResidentialInspectionsExpectedInNextYear: 0,

      numberOfResidentialOverInspectionsInThisYear: 0,
      revenueFromResidentialOverInspectionsInThisYear: 0,
      numberOfResidentialOverInspectionsExpectedInNextYear: 0,
      revenueFromResidentialOverInspectionsExpectedInNextYear: 0,

      numberOfCommercialInspectionsInThisYear: 0,
      revenueFromCommercialInspectionsInThisYear: 0,
      numberOfCommercialInspectionsExpectedInNextYear: 0,
      revenueFromCommercialInspectionsExpectedInNextYear: 0,

      numberOfOtherInspectionsInThisYear: 0,
      revenueFromOtherInspectionsInThisYear: 0,
      numberOfOtherInspectionsExpectedInNextYear: 0,
      revenueFromOtherInspectionsExpectedInNextYear: 0,
      // #8
      haveYourExperiencedBankruptcyInLast7Years: undefined,
      bankruptcyReportMode: [],

      // Operations
      // #9
      singleClientProvidesMt25PercentRevenue: undefined,
      singleClientProvidesMt25PercentDetails: '',
      // #10
      complianceInspections: undefined,
      complianceInspectionsDetails: '',
      // #11
      applicantExclusiveToAnyCompany: undefined,
      exclusiveInspectorDetails: '',
      // #12
      involvedInAuctionOfPersonalProperty: undefined,
      auctionsPersonalProperty: '',
      // #13
      providesOtherServices: undefined,
      otherServicesDetails: '',
      // // #14
      // applicantOrAssociateProvidesOtherServices: undefined,
      // applicantOrAssociateProvidesOtherServicesDetails: undefined,
      // #15
      enteredLimitedLiabilityContract: undefined,
      enteredLimitedLiabilityContractDetails: '',
      // #16
      performInspectionsOnOwnProperty: undefined,
      performInspectionsDetailsOnOwnProperty: '',
      // #17
      providesRepairWorkOnInspectedProperty: undefined,
      providesRepairWorkOnInspectedPropertyDetails: '',
      // #18
      applicantOrAssociateHasAnyOtherProfessionalLicense: undefined,
      otherProfessionalLicense1: '',
      otherProfessionalLicense2: '',
      otherProfessionalLicense3: '',
      otherProfessionalLicense4: '',
      applicantOrAssociateReportMode: [],

      // Risk Management
      // #19
      isPreInspectionAgreementAlwaysSigned: undefined,
      // #20
      preInspectionAgreementSource: undefined,
      preInspectionAgreementSourceOtherDetails: '',
      // #21
      preInspectionAgreementHasLimitationOfLiabilityClause: undefined,
      // #22
      applicantTakesDigitalPhotosOfInspections: undefined,
      isThereAMethodToAuthenticatePhotoDatetime: undefined,
      // #23
      listOfInspectionStandards: undefined,
      // #24
      listOfProfessionalAssociations: undefined,
      professionalAssociationsApplicantBelongs: undefined,
      // #25
      applicantTakesContinuingTrainingYearly: undefined,
      // #26
      isInspectionReportStandardized: undefined,
      homeGaugeInspectionReportStandardized: undefined,
      inspectionReportMode: [],
      // #27
      averageOfMoreThan3InspectionsPerDayPerInspector: undefined,
      moreThan3InspectionsDetails: undefined,

      // Staff/Additional Inspectors
      // #28
      homeInspectorsFullTime: 0,
      homeInspectorsPartTime: 0,
      nonInspectorsFullTime: 0,
      nonInspectorsPartTime: 0,
      // #28.a
      homeInspector1: '',
      homeInspector2: '',
      homeInspector3: '',
      homeInspector4: '',
      // #29
      doYouUseIndependentContractors: undefined,
      listOfIndependentContractorsToBeInsured: {},
      // #30
      areAllHomeInspectorsLicensedWhereStateRequires: undefined,

      // Insurance & Coverages
      // #31
      isFirmCurrentlyInsured: undefined,
      // #32
      desiredCoverage: [],
      desiredCoverageCustomLimit: '',
      // #33
      requestQuoteWithDollar5000Deductible: undefined,

      attestation: undefined,
      // requestQuoteWithDeductible: undefined,
      // #34
      poolAndSpaInspection: undefined,
      airQualityTesting: undefined,
      infraredThermalInspections: undefined,
      LeadPaintInspections: undefined,
      exteriorInsulationFinishSystemsInspections: undefined,
      greenBuildingInspections: undefined,
      windMitigationInspections: undefined,
      radonInspectionEndorsement: undefined,
      termiteWdiLiabilityIncidentalOnly: undefined,
      carbonMonoxide: undefined,
      rodentInspections: undefined,
      energyRating: undefined,
      drone: undefined,
      septicWaterTestingSewerScoping: undefined,
      moldTesting: undefined,
      cyberProtection: undefined,
      // Loss History
      // #35
      knowledgeOfActEoPotentialClaimFuture: undefined,
      // #36
      hasBeenSubjectToEoClaimPast: undefined,
      // #37
      criticizedCensoredSuspendedRevoked: undefined,
      // #38
      insuranceDeniedCancelledNonrenewedInsurance: undefined,
      insuranceDeniedCancelledNonrenewedInsuranceDetails: '',
      // #39
      coverageFile: null,
      // Page 4
      applicantPrincipleEsignature: '',
      applicantPrincipleEsignatureDatetime: moment().format('YYYY-MM-DD'),

      nklSignature: '',
      clientSignature: '',
      applicantRequestFrom: '',
      // Page 7
      servicesSignature: '',
      cyberCoverage: false,
      coverage: 0,
      slDisclosureSignature: '',
      ksOption: 1,
      ksCoverage: false,

      status: STATUS.Draft,
      pdf: null,
      noticeType: '',
      noticeTitle: '',
      emailPolicy: true,
      hearAboutUs: undefined,
      hearAboutUsOtherDetails: '',
      cyberTechnologyCoverage: false,
    },
    coverages: [],
    downPayment: false,
    payInFull: false,
    premiumCyberTechnologyCoverage: 125,
    submittedSlDisclosure: false,
    pageOneIsValid: false,
    pageTwoIsValid: false,
    pageThreeIsValid: false,
    pageFourIsValid: false,
    pageFiveIsValid: false,
    pageSixIsValid: false,
    pageSevenIsValid: false,
    pagefinalIsValid: false,
    pageSlDisclosureIsValid: false,
    signedInUser: false,
    errorMsg: null,
    paymentType: false,
  },
  getters: {
    totalRevenueOfInspectionsInThisYear: state => (
      Number(state.quote.revenueFromResidentialInspectionsInThisYear)
      + Number(state.quote.revenueFromResidentialOverInspectionsInThisYear)
      + Number(state.quote.revenueFromCommercialInspectionsInThisYear)
      + Number(state.quote.revenueFromOtherInspectionsInThisYear)
    ),
    totalNumberOfInspectionsInThisYear: state => (
      Number(state.quote.numberOfResidentialInspectionsInThisYear)
      + Number(state.quote.numberOfResidentialOverInspectionsInThisYear)
      + Number(state.quote.numberOfCommercialInspectionsInThisYear)
      + Number(state.quote.numberOfOtherInspectionsInThisYear)
    ),
    totalRevenueOfInspectionsInNextYear: state => (
      Number(state.quote.revenueFromResidentialInspectionsExpectedInNextYear)
      + Number(state.quote.revenueFromResidentialOverInspectionsExpectedInNextYear)
      + Number(state.quote.revenueFromCommercialInspectionsExpectedInNextYear)
      + Number(state.quote.revenueFromOtherInspectionsExpectedInNextYear)
    ),
    totalNumberOfInspectionsInNextYear: state => (
      Number(state.quote.numberOfResidentialInspectionsExpectedInNextYear)
      + Number(state.quote.numberOfResidentialOverInspectionsExpectedInNextYear)
      + Number(state.quote.numberOfCommercialInspectionsExpectedInNextYear)
      + Number(state.quote.numberOfOtherInspectionsExpectedInNextYear)
    ),
  },
  actions: {
    createQuote({ state }) {
      state.errorMsg = null;
      Functions.xapi()
        .post('api/quote/', {
          ...Functions.snakeCaseKeys({
            ...state.quote,
            requestQuoteWithDollar5000Deductible: false, // disable this checkbox
          }),
          desired_coverage: COVERAGES.filter(coverage => state.quote.desiredCoverage.find(ele => ele === coverage)),
        })
        .then((res) => {
          state.coverages = Functions.convertObjectKeyToCamelCase(res.data).coverages;
          let page = '';
          if (state.quote.customer.state === 'AR') {
            page = 'home-inspector-ar-policy-holder-notice';
          } else if (state.quote.customer.state === 'ND') {
            page = 'home-inspector-nd-policy-holder-notice';
          } else if (state.quote.customer.state === 'WV') {
            page = 'home-inspector-wv-policy-holder-notice';
          } else if (state.quote.customer.state === 'WY') {
            page = 'home-inspector-wy-policy-holder-notice';
          } else if (state.quote.customer.state === 'NJ') {
            page = 'home-inspector-nj-policy-holder-notice';
          } else if (state.quote.customer.state === 'OH') {
            page = 'home-inspector-oh-policy-holder-notice';
          } else if (state.quote.customer.state === 'RI') {
            page = 'home-inspector-ri-policy-holder-notice';
          } else {
            page = 'home-inspector-representation';
          }
          router.push({
            name: page,

          });
        })
        .catch((error) => {
          const firstErrorMsg = (res) => {
            if (!Array.isArray(res)) {
              if (typeof res === 'object') {
                firstErrorMsg(res[Object.keys(res)[0]]);
              } else {
                return 'Server Error';
              }
            } else {
              state.errorMsg = res[0];
            }
          };

          firstErrorMsg(error.response.data);
        });
    },
    createFormalQuote({ state }) {
      state.errorMsg = null;
      Functions.xapi()
        .post('api/quote/create-formal-quote/', {
          ...Functions.snakeCaseKeys({
            ...state.quote,
            requestQuoteWithDollar5000Deductible: false, // disable this checkbox
          }),
          desired_coverage: COVERAGES.filter(coverage => state.quote.desiredCoverage.find(ele => ele === coverage)),
        })
        .then((res) => {
          state.coverages = Functions.convertObjectKeyToCamelCase(res.data).coverages;
          let page = '';
          if (state.quote.customer.state === 'AR') {
            page = 'home-inspector-ar-sl-disclosure';
          } else if (state.quote.customer.state === 'CA') {
            page = 'home-inspector-ca-sl-disclosure';
          } else if (state.quote.customer.state === 'FL') {
            page = 'home-inspector-fl-sl-disclosure';
          } else if (state.quote.customer.state === 'ND') {
            page = 'home-inspector-nd-sl-disclosure';
          } else if (state.quote.customer.state === 'WV') {
            page = 'home-inspector-wv-sl-disclosure';
          } else if (state.quote.customer.state === 'WY') {
            page = 'home-inspector-wy-sl-disclosure';
          } else if (state.quote.customer.state === 'KS') {
            page = 'home-inspector-ks-sl-disclosure';
          } else if (state.quote.customer.state === 'NJ') {
            page = 'home-inspector-nj-sl-disclosure';
          } else if (state.quote.customer.state === 'NE') {
            page = 'home-inspector-ne-sl-disclosure';
          } else if (state.quote.customer.state === 'WA') {
            page = 'home-inspector-wa-sl-disclosure';
          } else if (state.quote.customer.state === 'CT') {
            page = 'home-inspector-ct-sl-disclosure';
          } else if (state.quote.customer.state === 'MA') {
            page = 'home-inspector-ma-sl-disclosure';
          } else if (state.quote.customer.state === 'OH') {
            page = 'home-inspector-oh-sl-disclosure';
          } else if (state.quote.customer.state === 'NY') {
            page = 'home-inspector-ny-sl-disclosure';
          } else {
            page = 'home-inspector-representation';
          }
          state.submittedSlDisclosure = true;
          router.push({
            name: page,
          });
        })
        .catch((error) => {
          const firstErrorMsg = (res) => {
            if (!Array.isArray(res)) {
              if (typeof res === 'object') {
                firstErrorMsg(res[Object.keys(res)[0]]);
              } else {
                return 'Server Error';
              }
            } else {
              state.errorMsg = res[0];
            }
          };

          firstErrorMsg(error.response.data);
        });
    },
    createSlDisclosure({ state }) {
      state.errorMsg = null;
      Functions.xapi()
        .post('api/quote/create-sl-disclosure/', {
          ...Functions.snakeCaseKeys({
            ...state.quote,
            requestQuoteWithDollar5000Deductible: false, // disable this checkbox
          }),
          desired_coverage: COVERAGES.filter(coverage => state.quote.desiredCoverage.find(ele => ele === coverage)),
        })
        .then((res) => {
          state.coverages = Functions.convertObjectKeyToCamelCase(res.data).coverages;
          let page = '';
          if (router.currentRoute.name === 'home-inspector-ar-policy-holder-notice' || router.currentRoute.name === 'home-inspector-nd-policy-holder-notice' || router.currentRoute.name === 'home-inspector-nj-policy-holder-notice'
          || router.currentRoute.name === 'home-inspector-oh-policy-holder-notice' || router.currentRoute.name === 'home-inspector-ri-policy-holder-notice'
          || router.currentRoute.name === 'home-inspector-wv-policy-holder-notice' || router.currentRoute.name === 'home-inspector-wy-policy-holder-notice') {
            page = 'home-inspector-representation';
          } else {
            page = 'home-inspector-representation';
          }
          router.push({
            name: page,
          });
        })
        .catch((error) => {
          const firstErrorMsg = (res) => {
            if (!Array.isArray(res)) {
              if (typeof res === 'object') {
                firstErrorMsg(res[Object.keys(res)[0]]);
              } else {
                return 'Server Error';
              }
            } else {
              state.errorMsg = res[0];
            }
          };

          firstErrorMsg(error.response.data);
        });
    },
    createCustomer({ state }) {
      state.errorMsg = null;
      Functions.xapi()
        .post('api/customer/create-customer/', {
          ...Functions.snakeCaseKeys({
            ...state.quote.customer, // disable this checkbox
          }),
          // desired_coverage: COVERAGES.filter(coverage => state.quote.desiredCoverage.find(ele => ele === coverage)),
        })
        .then((res) => {
          state.quote.customer.actContactId = Functions.convertObjectKeyToCamelCase(res.data).actContactId;
          Functions.trackWhatConvertsLead(state.quote.customer);
          router.push({
            name: 'home-inspector-2',
          });
        })
        .catch((error) => {
          const firstErrorMsg = (res) => {
            if (!Array.isArray(res)) {
              if (typeof res === 'object') {
                firstErrorMsg(res[Object.keys(res)[0]]);
              } else {
                return 'Server Error';
              }
            } else {
              state.errorMsg = res[0];
            }
          };

          firstErrorMsg(error.response.data);
        });
    },
  },
};

const individualAppraiserModule = {
  namespaced: true,
  state: {
    individualAppraiser: {
      // page 1
      fullLegalNameOfAppraiser: '',
      businessNameOfAppraiser: '',
      customer: {
        actContactId: '',
        address: '',
        city: '',
        county: '',
        state: '',
        zipCode: '',
        phone: '',
        contactName: '',
        companyName: '',
        email: '',
        isIndividualAppraiser: '',
        appStatus: 1,
      },
      effectiveDate: null,
      retroactiveDate: null,
      noPriorCoverage: false,
      additionalBusinessInfo: '',
      emailPolicy: true,
      placeCoverageWithAlternativeInsuranceCompany: true,
      // page 2
      isTrainee: null,
      doNotAppraiseAnyRealEstate: null,
      notDisciplinedByAnyState: null,
      noClaimsReported: null,
      revenueIsDerivedFromResidentialAppraisals: null,
      notAppraisedAnyProperties: null,
      totalGrossRevenueNotExceed: null,
      haveAnyCommercialOffice: null,
      usBankRuptcyCodeStatus: null,
      insuranceAppStatus: null,
      limitOfCoverage: '1M/1M',
      // page 3
      amcExtensionCoverage: false,
      traineeCoverage: false,
      sendInfoForBipdCoverage: false,
      sendInfoForCyberLiabilityCoverage: false,
      // page 4
      appraiserEsignatureDatetime: moment().format('YYYY-MM-DD'),
      appraiserPrincipleEsignature: null,
      // page 5
      title: '',
      appSignature: '',
      // page 6
      clientSignature: '',
      quoteSignature: '',
      applicantRequestFrom: '',
    },
    premium: 0,
    fullLegalNameOfAppraiserValid: false,
    effectiveDateValid: false,
    retroactiveDateValid: false,
    pageOneIsValid: false,
    pageTwoIsValid: false,
    pageThreeIsValid: false,
    pageFourIsValid: false,
    pageFiveIsValid: false,
    pageSixIsValid: false,
    errorMsg: null,
    successMsg: null,
  },
  actions: {
    createIndividualAppraiser({ state }) {
      state.errorMsg = null;
      Functions.xapi()
        .post('api/individual-appraiser/', {
          ...Functions.snakeCaseKeys(state.individualAppraiser),
          effective_date: moment(state.individualAppraiser.effectiveDate).format('YYYY-MM-DD'),
          retroactive_date: moment(state.individualAppraiser.retroactiveDate).format('YYYY-MM-DD'),
          premium: state.premium,
        })
        .then((res) => {
          state.individualAppraiser.id = res.data.id;
          router.push({
            name: 'individual-appraiser-representation',
          });
        })
        .catch((error) => {
          const firstErrorMsg = (res) => {
            if (!Array.isArray(res)) {
              if (typeof res === 'object') {
                firstErrorMsg(res[Object.keys(res)[0]]);
              } else {
                return 'Server Error';
              }
            } else {
              state.errorMsg = res[0];
            }
          };

          firstErrorMsg(error.response.data);
        });
    },
    getPremium({ state }, { routeName }) {
      state.errorMsg = null;
      Functions.xapi()
        .get('api/individual-appraiser/get-premium', {
          params: {
            revenue_is_derived_from_residential_appraisals: state.individualAppraiser.revenueIsDerivedFromResidentialAppraisals,
            not_appraised_any_properties: state.individualAppraiser.notAppraisedAnyProperties,
            total_gross_revenue_not_exceed: state.individualAppraiser.totalGrossRevenueNotExceed,
            state: state.individualAppraiser.customer.state,
            limit_of_coverage: state.individualAppraiser.limitOfCoverage,
          },
        })
        .then((res) => {
          state.premium = res.data.premium;
          router.push({
            name: routeName,
          });
        })
        .catch((error) => {
          const firstErrorMsg = (res) => {
            if (!Array.isArray(res)) {
              if (typeof res === 'object') {
                firstErrorMsg(res[Object.keys(res)[0]]);
              } else {
                return 'Server Error';
              }
            } else {
              state.errorMsg = res[0];
            }
          };

          firstErrorMsg(error.response.data);
        });
    },
    requestFinanceAgreement({ state }, { id }) {
      state.errorMsg = null;
      state.successMsg = null;
      Functions.xapi()
        .post(`api/individual-appraiser/${id}/request-finance-agreement/`)
        .then((res) => {
          router.push({ name: 'individual-appraiser-email-sent' });
          // state.successMsg = 'Thank you. email has been sent.'
        })
        .catch((error) => {
          const firstErrorMsg = (res) => {
            if (!Array.isArray(res)) {
              if (typeof res === 'object') {
                firstErrorMsg(res[Object.keys(res)[0]]);
              } else {
                return 'Server Error';
              }
            } else {
              state.errorMsg = res[0];
            }
          };

          firstErrorMsg(error.response.data);
        });
    },
    createCustomer({ state }) {
      state.errorMsg = null;
      Functions.xapi()
        .post('api/customer/create-customer/', {
          ...Functions.snakeCaseKeys({
            ...state.individualAppraiser.customer, // disable this checkbox
          }),
          // desired_coverage: COVERAGES.filter(coverage => state.quote.desiredCoverage.find(ele => ele === coverage)),
        })
        .then((res) => {
          state.individualAppraiser.customer.actContactId = Functions.convertObjectKeyToCamelCase(res.data).actContactId;
          Functions.trackWhatConvertsLead(state.individualAppraiser.customer);
          router.push({
            name: 'individual-appraiser-2',
          });
        })
        .catch((error) => {
          const firstErrorMsg = (res) => {
            if (!Array.isArray(res)) {
              if (typeof res === 'object') {
                firstErrorMsg(res[Object.keys(res)[0]]);
              } else {
                return 'Server Error';
              }
            } else {
              state.errorMsg = res[0];
            }
          };

          firstErrorMsg(error.response.data);
        });
    },
  },
};

const rxApplicationModule = {
  namespaced: true,
  state: {
    rxApplication: {
      // page 1
      applicantFirmName: '',
      contact: '',
      customer: {
        actContactId: '',
        address: '',
        city: '',
        county: '',
        fax: null,
        state: '',
        zipCode: '',
        phone: '',
        contactName: '',
        companyName: '',
        email: '',
        isRxApplication: '',
        appStatus: 1,
        partnerName: '',
      },
      mailingAddress: '',
      numberOfProfessionalsEarningsGreaterThanTwentyThousand: '',
      numberOfProfessionalsEarningsLessThanTwentyThousand: '',
      annualNumberOfTransaction: '',
      grossCommissionIcomeFor12Months: '',
      statusOfInsured: null,
      newBusinessAccounts: false,
      effectiveDate: null,
      retroactiveDate: null,
      noPriorCoverage: null,
      renewalAccounts: false,
      expiringPolicyNumber: '',


      // noPriorCoverage: false,
      // additionalBusinessInfo: '',
      emailPolicy: true,
      // placeCoverageWithAlternativeInsuranceCompany: true,

      // page 2

      companyRevokedLiceseLast5Years: null,
      companyCancelledLast5Years: null,
      memberOfCompanyInvolvedBrokering: null,
      companyExclusiveListingAgreement: null,
      last3YearsGrossRevenue: null,
      claimMadeInPast5Years: null,
      memberOfApplicantProvidedServices: null,
      haveAnyCommercialOffice: null,


      // page 2 califonia
      memberOfCaliforniaAssosiation: undefined,
      applicantTransactionsDualAgency: undefined,
      applicantTransactionsAgentOwnedPropertySales: undefined,

      // page 3
      limitOfCoverage: '1M/1M',
      deductible: '5000',
      policyTerm: 'oneYear',

      // page 4
      appraiserEsignatureDatetime: moment().format('YYYY-MM-DD'),
      appraiserPrincipleEsignature: null,
      nameForFraudWarning: null,
      titleForFraudWarning: null,
      signatureForStateMoWy: '',
      nameForStateMoWy: '',
      titleForStateMoWy: '',
      // page 5
      title: '',
      name: '',
      appSignature: '',
      // page 6
      clientSignature: '',
      quoteSignature: '',
      applicantRequestFrom: '',
      slDisclosureSignature: '',
      hearAboutUs: undefined,
      hearAboutUsOtherDetails: '',
      nklSignature: '',
    },
    premium: 0,
    premiumStateTax: 0,
    totalPremium: 0,
    total: 0,
    orepFee: 60,
    applicantFirmNameValid: false,
    effectiveDateValid: false,
    retroactiveDateValid: false,
    pageOneIsValid: false,
    pageTwoIsValid: false,
    pageThreeIsValid: true,
    pageFourIsValid: false,
    pageFiveIsValid: false,
    pageSixIsValid: false,
    pageSevenIsValid: false,
    pageSlDisclosureIsValid: false,
    signedInUser: false,
    errorMsg: null,
    successMsg: null,
    paymentType: false,
    totalPremiumStateTax: 0,
    requestFinancingPaymentLink: ''
  },
  actions: {
    createRxApplication({ state }) {
      state.errorMsg = null;
      Functions.xapi()
        .post('api/rx-application/', {
          ...Functions.snakeCaseKeys(state.rxApplication),
          effective_date: moment(state.rxApplication.effectiveDate).format('YYYY-MM-DD'),
          retroactive_date: moment(state.rxApplication.retroactiveDate).format('YYYY-MM-DD'),
          premium: state.premium,
        })
        .then((res) => {
          state.rxApplication.id = res.data.id;
          state.requestFinancingPaymentLink = res.data.requestFinancingPaymentLink;
          let page = '';
          if (state.rxApplication.customer.state === 'WA') {
            page = 'rx-application-wa-sl-disclosure';
          } else {
            page = 'rx-application-representation';
          }
          router.push({
            name: page,
          });
        })
        .catch((error) => {
          const firstErrorMsg = (res) => {
            if (!Array.isArray(res)) {
              if (typeof res === 'object') {
                firstErrorMsg(res[Object.keys(res)[0]]);
              } else {
                return 'Server Error';
              }
            } else {
              state.errorMsg = res[0];
            }
          };

          firstErrorMsg(error.response.data);
        });
    },
    getPremium({ state }) {
      state.errorMsg = null;
      Functions.xapi()
        .get('api/rx-application/get-premium', {
          params: {
            deductible: state.rxApplication.deductible,
            limit_of_coverage: state.rxApplication.limitOfCoverage,
            state: state.rxApplication.customer.state,
          },
        })
        .then((res) => {
          state.premium = res.data.premium;
          state.premiumStateTax = res.data.premiumStateTax;
          state.total = res.data.premiumStateTax + res.data.premium;
          state.totalPremium = state.premium;
          state.totalPremiumStateTax = state.premiumStateTax;

          if (state.rxApplication.policyTerm == 'twoYears') {
            state.totalPremium = state.premium * 2;
            state.totalPremiumStateTax = state.premiumStateTax * 2;
            state.total = state.totalPremium + state.totalPremiumStateTax;
          }
        })
        .catch((error) => {
          const firstErrorMsg = (res) => {
            if (!Array.isArray(res)) {
              if (typeof res === 'object') {
                firstErrorMsg(res[Object.keys(res)[0]]);
              } else {
                return 'Server Error';
              }
            } else {
              state.errorMsg = res[0];
            }
          };

          firstErrorMsg(error.response.data.premium);
        });
    },
    requestFinanceAgreement({ state }, { id }) {
      state.errorMsg = null;
      state.successMsg = null;
      Functions.xapi()
        .get(`api/rx-application/${id}/request-finance-agreement/`)
        .then((res) => {
          // router.push({ name: 'individual-appraiser-email-sent' });
          // state.successMsg = 'Thank you. email has been sent.'
          state.rxApplication.applicantFirmName = res.data.applicantFirmName;
          state.rxApplication.customer.state = res.data.state;
          state.premium = res.data.premium;
          state.premiumStateTax = res.data.premiumStateTax;
          state.total = res.data.premiumStateTax + res.data.premium;

          state.totalPremium = state.premium;
          state.totalPremiumStateTax = state.premiumStateTax;

          state.rxApplication.policyTerm = res.data.policyTerm;
          state.rxApplication.deductible = res.data.deductible;
          state.rxApplication.limitOfCoverage = res.data.limitOfCoverage;
          state.rxApplication.customer.partnerName = res.data.partnerName;
          state.rxApplication.effectiveDate = res.data.effectiveDate;


          if (state.rxApplication.policyTerm == 'twoYears') {
            state.totalPremium = state.premium * 2;
            state.totalPremiumStateTax = state.premiumStateTax * 2;
            state.total = state.totalPremium + state.totalPremiumStateTax;
          }
        })
        .catch((error) => {
          const firstErrorMsg = (res) => {
            if (!Array.isArray(res)) {
              if (typeof res === 'object') {
                firstErrorMsg(res[Object.keys(res)[0]]);
              } else {
                return 'Server Error';
              }
            } else {
              state.errorMsg = res[0];
            }
          };

          firstErrorMsg(error.response.data);
        });
    },
    createSlDisclosure({ state }) {
      state.errorMsg = null;
      Functions.xapi()
        .post('api/rx-application/create-sl-disclosure/', {
          ...Functions.snakeCaseKeys({
            ...state.rxApplication,
            effective_date: moment(state.rxApplication.effectiveDate).format('YYYY-MM-DD'),
            retroactive_date: moment(state.rxApplication.retroactiveDate).format('YYYY-MM-DD'),
            premium: state.premium,
          }),
        })
        .then((res) => {
          router.push({
            name: 'rx-application-representation',

          });
        })
        .catch((error) => {
          const firstErrorMsg = (res) => {
            if (!Array.isArray(res)) {
              if (typeof res === 'object') {
                firstErrorMsg(res[Object.keys(res)[0]]);
              } else {
                return 'Server Error';
              }
            } else {
              state.errorMsg = res[0];
            }
          };

          firstErrorMsg(error.response.data);
        });
    },
    createCustomer({ state }) {
      state.errorMsg = null;
      Functions.xapi()
        .post('api/customer/create-customer/', {
          ...Functions.snakeCaseKeys({
            ...state.rxApplication.customer, // disable this checkbox
          }),
          // desired_coverage: COVERAGES.filter(coverage => state.rxApplication.desiredCoverage.find(ele => ele === coverage)),
        })
        .then((res) => {
          state.rxApplication.customer.actContactId = Functions.convertObjectKeyToCamelCase(res.data).actContactId;
          Functions.trackWhatConvertsLead(state.rxApplication.customer);
          let page = 'rx-application-2';
          if (state.rxApplication.customer.state === 'CA') {
            page = 'rx-application-ca-2';
          }
          router.push({
            name: page,
          });
        })
        .catch((error) => {
          const firstErrorMsg = (res) => {
            if (!Array.isArray(res)) {
              if (typeof res === 'object') {
                firstErrorMsg(res[Object.keys(res)[0]]);
              } else {
                return 'Server Error';
              }
            } else {
              state.errorMsg = res[0];
            }
          };

          firstErrorMsg(error.response.data);
        });
    },
  },
};


const axApplicationModule = {
  namespaced: true,
  state: {
    axApplication: {
      // page 1
      fullLegalNameOfAppraiser: '',
      firmNameOfAppraiser: '',
      customer: {
        actContactId: '',
        address: '',
        city: '',
        county: '',
        fax: null,
        state: '',
        zipCode: '',
        phone: '',
        contactName: '',
        companyName: '',
        email: '',
        isAxApplication: '',
        appStatus: 1,
        partnerName: '',
      },
      mailingAddress: '',
      effectiveDate: null,
      retroactiveDate: null,
      noPriorCoverage: null,
      professionalAssociation: null,
      professionalAssociationDetails: '',
      emailPolicy: true,

      // page 2
      isTrainee: null,
      doNotAppraiseAnyRealEstate: null,
      notDisciplinedByAnyState: null,
      noClaimsReported: null,
      revenueIsDerivedFromResidentialAppraisals: null,
      notAppraisedAnyProperties: null,
      totalGrossRevenueNotExceed: null,
      haveAnyCommercialOffice: null,

      numberOfDisciplinaryActionsInLastFiveYears: '',
      numberOfClaimsInLastFiveYears: '',
      numberOfIncurredLossesInLastFiveYears: '',
      limitOfCoverage: '1M/1M',

      // page 3
      firstCoverage: false,
      traineeCoverage: false,
      mgmtCoverage: false,
      cyberTechnologyCoverage: true,

      // page 4
      appraiserEsignatureDatetime: moment().format('YYYY-MM-DD'),
      appraiserPrincipleEsignature: null,
      nameForFraudWarning: null,
      titleForFraudWarning: null,
      signatureForStateMoWy: '',
      nameForStateMoWy: '',
      titleForStateMoWy: '',
      nklTitle: '',
      nklName: '',
      nklAppSignature: '',
      // page 5
      title: '',
      name: '',
      appSignature: '',
      // page 6
      clientSignature: '',
      quoteSignature: '',
      applicantRequestFrom: '',
      slDisclosureSignature: '',
      hearAboutUs: undefined,
      hearAboutUsOtherDetails: ''
    },
    checkIfMailAddressSame: false,
    premium: 0,
    stateTax: 0,
    totalPremium: 0,
    premiumFirstCoverage: 0,
    premiumTraineeCoverage: 0,
    premiumCyberTechnologyCoverage: 125,
    premiumMgmtCoverage: 0,
    fullLegalNameOfAppraiserValid: false,
    effectiveDateValid: false,
    retroactiveDateValid: false,
    pageOneIsValid: false,
    pageTwoIsValid: false,
    pageThreeIsValid: false,
    pageFourIsValid: false,
    pageFiveIsValid: false,
    pageSixIsValid: false,
    pageSlDisclosureIsValid: false,
    signedInUser: false,
    emailPolicy: true,
    errorMsg: null,
    successMsg: null,
    paymentType: false,
    requestFinancingPaymentLinkWithOutCyberTechnology: '',
    requestFinancingPaymentLinkWithCyberTechnology: '',
  },
  actions: {
    createAxApplication({ state }) {
      state.errorMsg = null;
      Functions.xapi()
        .post('api/ax-application/', {
          ...Functions.snakeCaseKeys(state.axApplication),
          effective_date: moment(state.axApplication.effectiveDate).format('YYYY-MM-DD'),
          retroactive_date: moment(state.axApplication.retroactiveDate).format('YYYY-MM-DD'),
          premium: state.premium,
          premiumFirstCoverage: state.premiumFirstCoverage,
          premiumTraineeCoverage: state.premiumTraineeCoverage,
          premiumMgmtCoverage: state.premiumMgmtCoverage,
          premiumCyberTechnologyCoverage: state.premiumCyberTechnologyCoverage,

        })
        .then((res) => {
          state.axApplication.id = res.data.id;
          state.requestFinancingPaymentLinkWithOutCyberTechnology = res.data.paymentLinkWithOutCyberTechnology;
          state.requestFinancingPaymentLinkWithCyberTechnology = res.data.paymentLinkWithCyberTechnology;
          let page = '';
          if (state.axApplication.customer.state === 'WA') {
            page = 'ax-application-wa-sl-disclosure';
          } else if (state.axApplication.customer.state === 'MA') {
            page = 'ax-application-ma-sl-disclosure';
          } else if (state.axApplication.customer.state === 'CT') {
            page = 'ax-application-ct-sl-disclosure';
          } else if (state.axApplication.customer.state === 'NY') {
            page = 'ax-application-ny-notice-of-excess';
          } else {
            page = 'ax-application-representation';
          }
          router.push({
            name: page,
          });
        })
        .catch((error) => {
          const firstErrorMsg = (res) => {
            if (!Array.isArray(res)) {
              if (typeof res === 'object') {
                firstErrorMsg(res[Object.keys(res)[0]]);
              } else {
                return 'Server Error';
              }
            } else {
              state.errorMsg = res[0];
            }
          };

          firstErrorMsg(error.response.data);
        });
    },
    getPremium({ state }) {
      state.errorMsg = null;
      Functions.xapi()
        .get('api/ax-application/get-premium', {
          params: {
            revenue_is_derived_from_residential_appraisals: state.axApplication.revenueIsDerivedFromResidentialAppraisals,
            not_appraised_any_properties: state.axApplication.notAppraisedAnyProperties,
            total_gross_revenue_not_exceed: state.axApplication.totalGrossRevenueNotExceed,
            have_any_commercial_office: state.axApplication.haveAnyCommercialOffice,
            state: state.axApplication.customer.state,
            county: state.axApplication.customer.county,
            city: state.axApplication.customer.city,
            limit_of_coverage: state.axApplication.limitOfCoverage,
            trainee_coverage: state.axApplication.traineeCoverage,
            mgmt_coverage: state.axApplication.mgmtCoverage,
            cyber_technology_coverage: state.axApplication.cyberTechnologyCoverage,
          },
        })
        .then((res) => {
          state.premium = res.data.premium;
          state.premiumFirstCoverage = res.data.premiumFirstCoverage;
          state.premiumTraineeCoverage = res.data.premiumTraineeCoverage;
          state.premiumMgmtCoverage = res.data.premiumMgmtCoverage;
          state.premiumCyberTechnologyCoverage = res.data.premiumCyberTechnologyCoverage;

          state.stateTax = res.data.stateTax;
          state.totalPremium = res.data.totalPremium;
        })
        .catch((error) => {
          const firstErrorMsg = (res) => {
            if (!Array.isArray(res)) {
              if (typeof res === 'object') {
                firstErrorMsg(res[Object.keys(res)[0]]);
              } else {
                return 'Server Error';
              }
            } else {
              state.errorMsg = res[0];
            }
          };

          firstErrorMsg(error.response.data);
        });
    },
    requestFinanceAgreement({ state }, { id }) {
      state.errorMsg = null;
      state.successMsg = null;
      Functions.xapi()
        .get(`api/ax-application/${id}/request-finance-agreement/`)
        .then((res) => {
          state.axApplication.fullLegalNameOfAppraiser = res.data.fullLegalNameOfAppraiser;
          state.axApplication.traineeCoverage = res.data.traineeCoverage;
          state.axApplication.cyberTechnologyCoverage = res.data.cyberTechnologyCoverage;
          state.axApplication.mgmtCoverage = res.data.mgmtCoverage;
          state.axApplication.firstCoverage = res.data.firstCoverage;
          state.axApplication.limitOfCoverage = res.data.limitOfCoverage;
          state.axApplication.customer.state = res.data.state;
          state.premium = res.data.premium;
          state.stateTax = res.data.stateTax;
          state.premiumFirstCoverage = res.data.premiumFirstCoverage;
          state.premiumTraineeCoverage = res.data.premiumTraineeCoverage;
          state.premiumCyberTechnologyCoverage = res.data.premiumCyberTechnologyCoverage;
          state.premiumMgmtCoverage = res.data.premiumMgmtCoverage;
          state.axApplication.customer.partnerName = res.data.partnerName;
          state.axApplication.effectiveDate = res.data.effectiveDate;
          // state.premiumFirstCoverage = res.data.premiumFirstCoverage;
          // state.premiumTraineeCoverage = res.data.premiumTraineeCoverage;
          // state.premiumMgmtCoverage = res.data.premiumMgmtCoverage;
          // router.push({ name: 'ax-application-payment' });
          // state.successMsg = 'Thank you. email has been sent.'
        })
        .catch((error) => {
          const firstErrorMsg = (res) => {
            if (!Array.isArray(res)) {
              if (typeof res === 'object') {
                firstErrorMsg(res[Object.keys(res)[0]]);
              } else {
                return 'Server Error';
              }
            } else {
              state.errorMsg = res[0];
            }
          };

          firstErrorMsg(error.response.data);
        });
    },
    createCustomer({ state }) {
      state.errorMsg = null;
      Functions.xapi()
        .post('api/customer/create-customer/', {
          ...Functions.snakeCaseKeys({
            ...state.axApplication.customer, // disable this checkbox
          }),
          // desired_coverage: COVERAGES.filter(coverage => state.quote.desiredCoverage.find(ele => ele === coverage)),
        })
        .then((res) => {
          state.axApplication.customer.actContactId = Functions.convertObjectKeyToCamelCase(res.data).actContactId;
          Functions.trackWhatConvertsLead(state.axApplication.customer);
          router.push({
            name: 'ax-application-2',
          });
        })
        .catch((error) => {
          const firstErrorMsg = (res) => {
            if (!Array.isArray(res)) {
              if (typeof res === 'object') {
                firstErrorMsg(res[Object.keys(res)[0]]);
              } else {
                return 'Server Error';
              }
            } else {
              state.errorMsg = res[0];
            }
          };

          firstErrorMsg(error.response.data);
        });
    },
    createSlDisclosure({ state }) {
      state.errorMsg = null;
      Functions.xapi()
        .post('api/ax-application/create-sl-disclosure/', {
          ...Functions.snakeCaseKeys(state.axApplication),
          effective_date: moment(state.axApplication.effectiveDate).format('YYYY-MM-DD'),
          retroactive_date: moment(state.axApplication.retroactiveDate).format('YYYY-MM-DD'),
          premium: state.premium,
          premiumFirstCoverage: state.premiumFirstCoverage,
          premiumTraineeCoverage: state.premiumTraineeCoverage,
          premiumMgmtCoverage: state.premiumMgmtCoverage,
          premiumCyberTechnologyCoverage: state.premiumCyberTechnologyCoverage,

        })
        .then((res) => {
          router.push({
            name: 'ax-application-representation',

          });
        })
        .catch((error) => {
          const firstErrorMsg = (res) => {
            if (!Array.isArray(res)) {
              if (typeof res === 'object') {
                firstErrorMsg(res[Object.keys(res)[0]]);
              } else {
                return 'Server Error';
              }
            } else {
              state.errorMsg = res[0];
            }
          };

          firstErrorMsg(error.response.data);
        });
    },
  },
};
const ipfsModule = {
  namespaced: true,
  state: {
    ipfs: {
      // page 1
      individualName: '',
    },
    total: 0,
    grandTotal: 0,
    processingFee: 0,
    financefee: 0,
    premium: '',
    orepfee: 60,
    effectiveDate: null,
    errorMsg: null,
    successMsg: null,
    paymentType: false,
    pageOneIsValid: false,
  },
};
const customerModule = {
  namespaced: true,
  state: {
    customerDetail: {
      actContactId: '',
      county: null,
      fax: null,
      riskid: '',
      zipCode: '',
      address: '',
      city: '',
      state: '',
      phone: '',
      email: '',
      contactName: '',
      companyName: '',
      policyStartDate: '',
      policyExpireDate: '',
      policyPriorActsDate: '',
      isIndividualAppraiser: '',
      isGroupAppraiser: '',
      isHomeInspector: '',
      isRxApplication: '',
      isAxApplication: '',
      isStandardApplication: '',
      isPiApplication: '',
      isSipApplication: '',
      isRcApplication: '',
      isInsuranceAgentApplication: '',
      isMgaApplication: '',
      isPpiApplication: '',
      isQuickQuoteApplication: '',
      partnerName: '',
    },
    emailAddress: 'info@orep.org',
    pageTwoIsValid: false,
    errorMsg: null,
  },

  actions: {
    sendEmail({ state }, { routeName }) {
      state.errorMsg = null;
      console.log(this.getters.getHostname);  // Corrected to use `this.getters.getHostname`
      Functions.xapi()
        .get('api/login/forget-id', {
          params: {
            email: state.customerDetail.email,
          },
        })
        .then((res) => {
          router.push({
            name: routeName,
          });
        })
        .catch((error) => {
          const firstErrorMsg = (res) => {
            if (!Array.isArray(res)) {
              if (typeof res === 'object') {
                firstErrorMsg(res[Object.keys(res)[0]]);
              } else {
                return 'Server Error';
              }
            } else {
              state.errorMsg = res[0];
            }
          };
          Vue.notify({
            group: 'error',
            type: 'error',
            title: 'Incorrect Email',
            text: 'Provided Email Address is Incorrect!',
          });
          firstErrorMsg(error.response.data);
        });
    },
    getDetails({ state }, { routeName }) {
      state.errorMsg = null;

      Functions.xapi()
        .get('api/login', {
          params: {

            riskid: state.customerDetail.actContactId,
            zipcode: state.customerDetail.zipCode,

          },
        })
        .then((res) => {
          // eslint-disable-next-line no-param-reassign
          res.data = Functions.convertObjectKeyToCamelCase(res.data);
          state.customerDetail = res.data;
          if (state.customerDetail.isHomeInspector) {
            homeInspectorModule.state.quote.customer = res.data;
            homeInspectorModule.state.quote.fullLegalNameOfApplicant = res.data.companyName;
            homeInspectorModule.state.quote.nameOfPrincipalHomeInspector = res.data.contactName;
            state.emailAddress = 'inspectors@orep.org';
            homeInspectorModule.state.quote.customer.actContactId = res.data.actContactId;
            homeInspectorModule.state.quote.signedInUser = true;
          } else if (state.customerDetail.isGroupAppraiser) {
            groupAppraiserModule.state.groupAppraiser.customer = res.data;
            groupAppraiserModule.state.groupAppraiser.nameOfPrimaryLicensed = res.data.contactName;
            groupAppraiserModule.state.groupAppraiser.nameOfApplicant = res.data.companyName;
            groupAppraiserModule.state.groupAppraiser.retroactiveDate = res.data.policyPriorActsDate;

            groupAppraiserModule.state.groupAppraiser.mailingAddress = res.data.address;
            groupAppraiserModule.state.groupAppraiser.mailingCity = res.data.city;
            groupAppraiserModule.state.groupAppraiser.mailingState = res.data.state;
            groupAppraiserModule.state.groupAppraiser.mailingZipCode = res.data.zipCode;
            groupAppraiserModule.state.groupAppraiser.customer.actContactId = res.data.actContactId;
          } else if (state.customerDetail.isIndividualAppraiser) {
            individualAppraiserModule.state.individualAppraiser.fullLegalNameOfAppraiser = res.data.contactName;
            individualAppraiserModule.state.individualAppraiser.retroactiveDate = res.data.policyPriorActsDate;
            if (individualAppraiserModule.state.individualAppraiser.fullLegalNameOfAppraiser !== '') {
              individualAppraiserModule.state.fullLegalNameOfAppraiserValid = true;
            }
            if (individualAppraiserModule.state.individualAppraiser.effectiveDate !== null) {
              // individualAppraiserModule.state.effectiveDateValid = false;
            }
            if (individualAppraiserModule.state.individualAppraiser.retroactiveDate !== null) {
              individualAppraiserModule.state.retroactiveDateValid = true;
            }

            individualAppraiserModule.state.individualAppraiser.customer.actContactId = res.data.actContactId;
          } else if (state.customerDetail.isAxApplication) {
            // individualAppraiserModule.state.individualAppraiser.customer = res.data;
            axApplicationModule.state.axApplication.fullLegalNameOfAppraiser = res.data.contactName;
            axApplicationModule.state.axApplication.firmNameOfAppraiser = res.data.companyName;
            // axApplicationModule.state.axApplication.effectiveDate = res.data.policyExpireDate;
            axApplicationModule.state.axApplication.retroactiveDate = res.data.policyPriorActsDate;
            if (axApplicationModule.state.axApplication.fullLegalNameOfAppraiser !== '') {
              axApplicationModule.state.fullLegalNameOfAppraiserValid = true;
            }
            if (axApplicationModule.state.axApplication.effectiveDate !== null) {
              // axApplicationModule.state.effectiveDateValid = false;
            }
            if (axApplicationModule.state.axApplication.retroactiveDate !== null) {
              axApplicationModule.state.retroactiveDateValid = true;
            }

            axApplicationModule.state.axApplication.customer.actContactId = res.data.actContactId;
            axApplicationModule.state.axApplication.customer.partnerName = res.data.partnerName;
            axApplicationModule.state.signedInUser = true;
          } else if (state.customerDetail.isStandardApplication) {
            standardApplicationModule.state.standardApplication.customer = res.data;
            standardApplicationModule.state.standardApplication.nameOfPrimaryLicensed = res.data.contactName;
            standardApplicationModule.state.standardApplication.nameOfApplicant = res.data.companyName;
            standardApplicationModule.state.standardApplication.retroactiveDate = res.data.policyPriorActsDate;
            standardApplicationModule.state.standardApplication.mailingAddress = res.data.address;
            standardApplicationModule.state.standardApplication.mailingCity = res.data.city;
            standardApplicationModule.state.standardApplication.mailingState = res.data.state;
            standardApplicationModule.state.standardApplication.mailingZipCode = res.data.zipCode;
            standardApplicationModule.state.standardApplication.customer.actContactId = res.data.actContactId;
            standardApplicationModule.state.standardApplication.customer.partnerName = res.data.partnerName;
            if (standardApplicationModule.state.standardApplication.effectiveDate !== null) {
              // standardApplicationModule.state.effectiveDateValid = false;
            }
            if (standardApplicationModule.state.standardApplication.retroactiveDate !== null) {
              standardApplicationModule.state.retroactiveDateValid = true;
            }
            standardApplicationModule.state.signedInUser = true;
          } else if (state.customerDetail.isRxApplication) {
            rxApplicationModule.state.rxApplication.contact = res.data.contactName;
            rxApplicationModule.state.rxApplication.retroactiveDate = res.data.policyPriorActsDate;
            if (rxApplicationModule.state.rxApplication.contact !== '') {
              rxApplicationModule.state.contact = true;
            }
            if (rxApplicationModule.state.rxApplication.effectiveDate !== null) {
              // rxApplicationModule.state.effectiveDateValid = false;
            }
            if (rxApplicationModule.state.rxApplication.retroactiveDate !== null) {
              rxApplicationModule.state.retroactiveDateValid = true;
            }
            rxApplicationModule.state.rxApplication.customer.actContactId = res.data.actContactId;
            rxApplicationModule.state.rxApplication.customer.partnerName = res.data.partnerName;
            rxApplicationModule.state.signedInUser = true;
          } else if (state.customerDetail.isPiApplication) {
            piApplicationModule.state.piApplication.contact = res.data.contactName;
            piApplicationModule.state.piApplication.nameOfApplicant = res.data.companyName;
            piApplicationModule.state.piApplication.customer.actContactId = res.data.actContactId;
            piApplicationModule.state.piApplication.customer.partnerName = res.data.partnerName;
            piApplicationModule.state.signedInUser = true;
          } else if (state.customerDetail.isSipApplication) {
            sipApplicationModule.state.sipApplication.nameOfApplicant = res.data.companyName;
            sipApplicationModule.state.sipApplication.customer.actContactId = res.data.actContactId;
            sipApplicationModule.state.sipApplication.customer.partnerName = res.data.partnerName;
            sipApplicationModule.state.sipApplication.retroactiveDate = res.data.retroactiveDate;

            if (sipApplicationModule.state.sipApplication.effectiveDate !== null) {
              // rxApplicationModule.state.effectiveDateValid = false;
            }
            if (sipApplicationModule.state.sipApplication.retroactiveDate !== null) {
              sipApplicationModule.state.retroactiveDateValid = true;
            }
          } else if (state.customerDetail.isPpiApplication) {
            ppiApplicationModule.state.ppiApplication.nameOfApplicant = res.data.companyName;
            ppiApplicationModule.state.ppiApplication.customer.actContactId = res.data.actContactId;
            ppiApplicationModule.state.ppiApplication.customer.partnerName = res.data.partnerName;
            ppiApplicationModule.state.ppiApplication.retroactiveDate = res.data.retroactiveDate;

            if (ppiApplicationModule.state.ppiApplication.effectiveDate !== null) {
              // rxApplicationModule.state.effectiveDateValid = false;
            }
            if (ppiApplicationModule.state.ppiApplication.retroactiveDate !== null) {
              ppiApplicationModule.state.retroactiveDateValid = true;
            }
          } else if (state.customerDetail.isRcApplication) {
            rcApplicationModule.state.rcApplication.namedInsured = res.data.contactName;
            rcApplicationModule.state.rcApplication.customer.actContactId = res.data.actContactId;
            rcApplicationModule.state.rcApplication.customer.partnerName = res.data.partnerName;
            if (rcApplicationModule.state.rcApplication.effectiveDate !== null) {
              // rxApplicationModule.state.effectiveDateValid = false;
            }
          }
          else if (state.customerDetail.isQuickQuoteApplication) {
            quickQuoteModule.state.quickQuote.nameOfApplicant = res.data.contactName;
            quickQuoteModule.state.quickQuote.customer.actContactId = res.data.actContactId;
            quickQuoteModule.state.quickQuote.customer.partnerName = res.data.partnerName;
            if (quickQuoteModule.state.quickQuote.effectiveDate !== null) {
              // rxApplicationModule.state.effectiveDateValid = false;
            }
          }
          else if (state.customerDetail.isMgaApplication) {
            mgaApplicationModule.state.mgaApplication.namedInsured = res.data.contactName;
            mgaApplicationModule.state.mgaApplication.customer.actContactId = res.data.actContactId;
            mgaApplicationModule.state.mgaApplication.customer.partnerName = res.data.partnerName;
            mgaApplicationModule.state.mgaApplication.customer.actContactId = res.data.actContactId;
            mgaApplicationModule.state.mgaApplication.customer = res.data;
            mgaApplicationModule.state.mgaApplication.businessName = res.data.contactName;
            mgaApplicationModule.state.mgaApplication.nameOfApplicant = res.data.companyName;
            mgaApplicationModule.state.mgaApplication.retroactiveDate = res.data.policyPriorActsDate;
            if (mgaApplicationModule.state.mgaApplication.effectiveDate !== null) {
              // rxApplicationModule.state.effectiveDateValid = false;
            }
          }
          else if (state.customerDetail.isInsuranceAgentApplication) {

            insuranceAgentApplicationModule.state.insuranceAgentApplication.customer = res.data;
            insuranceAgentApplicationModule.state.insuranceAgentApplication.namedInsured = res.data.contactName;
            insuranceAgentApplicationModule.state.insuranceAgentApplication.customer.actContactId = res.data.actContactId;
            insuranceAgentApplicationModule.state.insuranceAgentApplication.customer.partnerName = res.data.partnerName;
            insuranceAgentApplicationModule.state.insuranceAgentApplication.customer = res.data;
            insuranceAgentApplicationModule.state.insuranceAgentApplication.businessName = res.data.contactName;
            insuranceAgentApplicationModule.state.insuranceAgentApplication.nameOfApplicant = res.data.companyName;
            insuranceAgentApplicationModule.state.insuranceAgentApplication.retroactiveDate = res.data.policyPriorActsDate;
            insuranceAgentApplicationModule.state.insuranceAgentApplication.customer.actContactId = res.data.actContactId;
            // state.customerDetail = state.customerDetail.customer
            // insuranceAgentApplicationModule.state.insuranceAgentApplication.customer.actContactId = res.data.actContactId;
            // insuranceAgentApplicationModule.state.insuranceAgentApplication.customer.partnerName = res.data.partnerName;
            // insuranceAgentApplicationModule.state.insuranceAgentApplication.customer = res.data.customer;
            // insuranceAgentApplicationModule.state.insuranceAgentApplication.businessName = res.data.contactName;
            // insuranceAgentApplicationModule.state.insuranceAgentApplication.nameOfApplicant = res.data.companyName;
            // insuranceAgentApplicationModule.state.insuranceAgentApplication.retroactiveDate = res.data.policyPriorActsDate;
            // insuranceAgentApplicationModule.state.insuranceAgentApplication.mailingAddress = res.data.address;
            // insuranceAgentApplicationModule.state.insuranceAgentApplication.mailingCity = res.data.city;
            // insuranceAgentApplicationModule.state.insuranceAgentApplication.mailingState = res.data.state;
            // insuranceAgentApplicationModule.state.insuranceAgentApplication.mailingZipCode = res.data.zipCode;
            delete insuranceAgentApplicationModule.state.insuranceAgentApplication.periodOne;
            delete insuranceAgentApplicationModule.state.insuranceAgentApplication.periodTwo;
            delete insuranceAgentApplicationModule.state.insuranceAgentApplication.estimateCommissionEarnOne;
            delete insuranceAgentApplicationModule.state.insuranceAgentApplication.estimateCommissionEarnTwo;
            delete insuranceAgentApplicationModule.state.insuranceAgentApplication.otherBusinessThanInsurance;
            delete insuranceAgentApplicationModule.state.insuranceAgentApplication.otherBusinessThanInsuranceDetails;
            delete insuranceAgentApplicationModule.state.insuranceAgentApplication.ownOtherFirm;
            delete insuranceAgentApplicationModule.state.insuranceAgentApplication.ownOtherFirmDetails;
            delete insuranceAgentApplicationModule.state.insuranceAgentApplication.past3YearsAgencyNameChanged;
            delete insuranceAgentApplicationModule.state.insuranceAgentApplication.past3YearsAgencyNameChangedDetails;
            delete insuranceAgentApplicationModule.state.insuranceAgentApplication.subjectToDisciplinaryAction;
            delete insuranceAgentApplicationModule.state.insuranceAgentApplication.subjectToDisciplinaryActionDetails;
            delete insuranceAgentApplicationModule.state.insuranceAgentApplication.suitsAgaintsApplicantInLast5Years;
            delete insuranceAgentApplicationModule.state.insuranceAgentApplication.suitsAgaintsApplicantInLast5YearsDetails;
            delete insuranceAgentApplicationModule.state.insuranceAgentApplication.claimMadeAgainstApplicant;
            delete insuranceAgentApplicationModule.state.insuranceAgentApplication.claimMadeAgainstApplicantDetails;

            delete insuranceAgentApplicationModule.state.insuranceAgentApplication.suitsAgaintsApplicantInLast5YearsDetails;
            delete insuranceAgentApplicationModule.state.insuranceAgentApplication.claimMadeAgainstApplicant;
            delete insuranceAgentApplicationModule.state.insuranceAgentApplication.claimMadeAgainstApplicantDetails;
            delete insuranceAgentApplicationModule.state.insuranceAgentApplication.nameForFraudWarning;
            delete insuranceAgentApplicationModule.state.insuranceAgentApplication.titleForFraudWarning;
            delete insuranceAgentApplicationModule.state.insuranceAgentApplication.clientSignature;
            delete insuranceAgentApplicationModule.state.insuranceAgentApplication.appraiserEsignatureDatetime;
            if (insuranceAgentApplicationModule.state.insuranceAgentApplication.effectiveDate !== null) {
              // rxApplicationModule.state.effectiveDateValid = false;
            }
          }

          if (state.customerDetail.partnerName === 'Mercer'){
            routeName = 'about-amba'
          }else if (state.customerDetail.partnerName === 'Realshield'){
            routeName = 'about-realshield'
          }
          else if (state.customerDetail.partnerName === 'IBD'){
            routeName = 'about-ibdpro'
          }
          else {
            routeName = 'about'
          }

          router.push({
            name: routeName,
          });
        })
        .catch((error) => {
          const firstErrorMsg = (res) => {
            if (!Array.isArray(res)) {
              if (typeof res === 'object') {
                firstErrorMsg(res[Object.keys(res)[0]]);
              } else {
                // eslint-disable-next-line no-console
                console.log('Server Error');
                // return 'Server Error';
                // confirm('Server Error')
              }
            } else {
              // state.errorMsg = res[0];
              console.log(res[0]);
            }
          };
          // eslint-disable-next-line no-restricted-globals
          Vue.notify({
            group: 'error',
            type: 'error',
            title: 'Incorrect Details',
            text: 'RISK ID or ZIPCODE is Invalid!',
          });

          firstErrorMsg(error.response.data);
        });
    },
  },
};


const groupAppraiserModule = {
  namespaced: true,
  state: {
    groupAppraiser: {
      // page 1
      // 1
      nameOfApplicant: '',
      nameOfPrimaryLicensed: '',
      customer: {
        actContactId: '',
        address: '',
        city: '',
        state: '',
        zipCode: '',
        phone: '',
        email: '',
        contactName: '',
        companyName: '',
        fax: '',
        isGroupAppraiser: '',
        appStatus: 1,
      },
      mailingAddress: '',
      mailingCity: '',
      mailingState: '',
      mailingZipCode: '',
      applicantOwnership: null,
      // 2
      dateFirmEstablished: '',
      // 3
      yearOfOwnerAssumedManagement: null,
      // 4
      yearOfOwnerLicensedAsAppraiser: null,
      yearOfOwnerLicensedAsAgent: null,
      yearOfOwnerLicensedAsBroker: null,
      // 5
      numberOfFullTimeProfessionals: null,
      // 6
      numberOfPartTimeProfessionals: null,
      // 7
      numberOfSupportStaff: null,
      // 8
      holdAtLeast15PercentOfAllProfessionals: null,
      // 9
      doesApplicantControlInOtherBusiness: null,
      doesApplicantControlInOtherBusinessDetails: '',
      // 10
      isApplicantControlledByOtherPerson: null,
      isApplicantControlledByOtherPersonDetails: '',

      // Page 2
      // 11
      // Single-family residential
      lastRevenueSingleFamily: 0,
      lastNumberSingleFamily: 0,
      nextRevenueSingleFamily: 0,
      nextNumberSingleFamily: 0,
      // Multi-family residential
      lastRevenueMultiFamily: 0,
      lastNumberMultiFamily: 0,
      nextRevenueMultiFamily: 0,
      nextNumberMultiFamily: 0,

      // Apartment or residental condo complexes
      lastRevenueResidentalCondo: 0,
      lastNumberResidentalCondo: 0,
      nextRevenueResidentalCondo: 0,
      nextNumberResidentalCondo: 0,
      // commercial properties
      lastRevenueCommercialProperties: 0,
      lastNumberCommercialProperties: 0,
      nextRevenueCommercialProperties: 0,
      nextNumberCommercialProperties: 0,

      // Farm land / Raw land
      lastRevenueFarmLand: 0,
      lastNumberFarmLand: 0,
      nextRevenueFarmLand: 0,
      nextNumberFarmLand: 0,
      // Residential Sales
      lastRevenueResidentialSales: 0,
      lastNumberResidentialSales: 0,
      nextRevenueResidentialSales: 0,
      nextNumberResidentialSales: 0,
      // Residential Leasing*
      lastRevenueResidentialLeasing: 0,
      lastNumberResidentialLeasing: 0,
      nextRevenueResidentialLeasing: 0,
      nextNumberResidentialLeasing: 0,
      // Owned Residential Property Sales
      lastRevenueOwnedResidentialProperty: 0,
      lastNumberOwnedResidentialProperty: 0,
      nextRevenueOwnedResidentialProperty: 0,
      nextNumberOwnedResidentialProperty: 0,
      // Commercial Sales*
      lastRevenueCommercialSales: 0,
      lastNumberCommercialSales: 0,
      nextRevenueCommercialSales: 0,
      nextNumberCommercialSales: 0,
      // Commercial Leasing*
      lastRevenueCommercialLeasing: 0,
      lastNumberCommercialLeasing: 0,
      nextRevenueCommercialLeasing: 0,
      nextNumberCommercialLeasing: 0,
      // Owned Commercial Property Sales
      lastRevenueOwnedCommercialProperty: 0,
      lastNumberOwnedCommercialProperty: 0,
      nextRevenueOwnedCommercialProperty: 0,
      nextNumberOwnedCommercialProperty: 0,

      // Property Management
      lastRevenuePropertyManagement: 0,
      lastNumberPropertyManagement: 0,
      nextRevenuePropertyManagement: 0,
      nextNumberPropertyManagement: 0,
      // Sale of Business Opportunities
      lastRevenueSalesOfBusiness: 0,
      lastNumberSalesOfBusiness: 0,
      nextRevenueSalesOfBusiness: 0,
      nextNumberSalesOfBusiness: 0,
      // Mortgage Brokering
      lastRevenueMortgageBrokering: 0,
      lastNumberMortgageBrokering: 0,
      nextRevenueMortgageBrokering: 0,
      nextNumberMortgageBrokering: 0,
      // Real Estate Consulting
      lastRevenueRealEstateConsulting: 0,
      lastNumberRealEstateConsulting: 0,
      nextRevenueRealEstateConsulting: 0,
      nextNumberRealEstateConsulting: 0,
      // Other
      lastRevenueOther: 0,
      lastNumberOther: 0,
      nextRevenueOther: 0,
      nextNumberOther: 0,

      // Details of Real Estate Consulting and Other from above
      detailsOfRealEstate1: '',
      detailsOfRealEstate2: '',
      detailsOfRealEstate3: '',
      // 12
      doYouAppraiseAnyRealEstate: null,
      // 13
      doYouPerformAppraisalsOnProperties: null,
      doYouPerformAppraisalsOnPropertiesDetails: '',
      // 14
      hasApplicantBeenInvolvedInAnyMerger: null,
      // 15
      doesApplicantTransactBusinessInMultipleStates: null,
      // 16
      wouldLikeCoverageForBothAppraisingAndSales: null,
      // Page 3
      areLicensedAsRealEstateAgent: null,
      doesApplicantHaveDocumentedProcedures: null,
      doesApplicantUseApprovedBoardOfRealtors: null,
      doesApplicantUseApprovedBoardOfRealtorsDetails: '',
      averageValueOfPropertiesSoldByApplicant: '',
      signedPropertyDisclosureForm: '',
      homeInspectionOrWrittenWaiver: '',
      homeWarrantyProgram: '',
      haveAnyOwnershipInterestInAnyProperty: null,
      haveAnyOwnershipInterestInAnyPropertyDetails: '',
      // 17
      doYouCurrentlyCarryProfessionalLiabilityInsurance: null,
      retroactiveDate: null,
      // 18
      limitOfCoverages: [],
      // 19
      deductible: [],
      // 20.a
      wantRealEstateAppraisalManagementCompanyExtension: null,
      // 20 b
      sendMeInformationOnCoverage: null,
      // 21
      hasAnyApplicationEverBeenDeclined: null,
      // 22
      isApplicantListInPart2AwareOfAnyCircumstance: null,
      // 23
      haveAnyClaimsEverBeenMadeAgainstApplicant: null,
      // 24
      hasApplicantListedPart2BeenSubjectOfDisciplinaryAction: null,
      explanation1: '',
      explanation2: '',
      explanation3: '',
      explanation4: '',
      explanation5: '',

      // 25
      usBankruptcyCode: null,
      // 26
      insuranceAppStatus: null,
      // Page 4
      applicantEsignatureDate: moment().format('YYYY-MM-DD'),
      applicantEsignature: null,
      applicantRequestFrom: '',
    },
    pageOneIsValid: false,
    pageTwoIsValid: false,
    pageThreeIsValid: false,
    pageFourIsValid: false,
    errorMsg: null,
  },
  actions: {
    createGroupAppraiser({ state }) {
      state.errorMsg = null;
      Functions.xapi()
        .post('api/group-appraiser/', {
          ...Functions.snakeCaseKeys(state.groupAppraiser),
          retroactive_date: moment(state.groupAppraiser.retroactiveDate).format('YYYY-MM-DD'),
        })
        .then((res) => {
          router.push({
            name: 'group-appraiser-representation',
          });
        })
        .catch((error) => {
          const firstErrorMsg = (res) => {
            if (!Array.isArray(res)) {
              if (typeof res === 'object') {
                firstErrorMsg(res[Object.keys(res)[0]]);
              } else {
                return 'Server Error';
              }
            } else {
              state.errorMsg = res[0];
            }
          };

          firstErrorMsg(error.response.data);
        });
    },
    createCustomer({ state }) {
      state.errorMsg = null;
      Functions.xapi()
        .post('api/customer/create-customer/', {
          ...Functions.snakeCaseKeys({
            ...state.groupAppraiser.customer, // disable this checkbox
          }),
          // desired_coverage: COVERAGES.filter(coverage => state.quote.desiredCoverage.find(ele => ele === coverage)),
        })
        .then((res) => {
          state.groupAppraiser.customer.actContactId = Functions.convertObjectKeyToCamelCase(res.data).actContactId;
          Functions.trackWhatConvertsLead(state.groupAppraiser.customer);
          router.push({
            name: 'group-appraiser-2',
          });
        })
        .catch((error) => {
          const firstErrorMsg = (res) => {
            if (!Array.isArray(res)) {
              if (typeof res === 'object') {
                firstErrorMsg(res[Object.keys(res)[0]]);
              } else {
                return 'Server Error';
              }
            } else {
              state.errorMsg = res[0];
            }
          };

          firstErrorMsg(error.response.data);
        });
    },

  },
};

const standardApplicationModule = {
  namespaced: true,
  state: {
    standardApplication: {
      // page 1
      // 1
      nameOfApplicant: '',
      nameOfPrimaryLicensed: '',
      customer: {
        actContactId: '',
        address: '',
        city: '',
        state: '',
        zipCode: '',
        phone: '',
        email: '',
        contactName: '',
        companyName: '',
        fax: '',
        isStandardApplication: '',
        appStatus: 1,
        partnerName: '',
      },
      mailingAddress: '',
      mailingCity: '',
      mailingState: '',
      mailingZipCode: '',

      // 2 a
      dateFirmEstablished: '',
      // 2 b
      yearOfOwnerAssumedManagement: null,
      // 2 c
      yearOfOwnerLicensedAsBroker: null,
      yearOfOwnerLicensedAsAppraiser: null,
      yearOfOwnerLicensedAsAgent: null,

      // 3
      applicantOwnership: null,

      // 4 a
      numberOfFullTimeProfessionals: 0,
      // 4 b
      numberOfPartTimeProfessionals: 0,
      // 4 c
      numberOfSupportStaff: null,
      numberOfInactiveProfessionals: null,
      // 5
      formalizedTrainingProgramProfessionals: null,
      // 6
      numberOfProfessionalsParticipatedEducation: '',

      // 7
      holdAtLeast15PercentOfAllProfessionals: null,

      // 8
      doesApplicantControlInOtherBusiness: null,
      doesApplicantControlInOtherBusinessDetails: '',
      // 9 a
      hasAnyMemberEngagedInDevelopment: null,
      // 9b
      engagedDevelopmentMode: [],
      incomeDerivedFromSaleOfResidentialProperties: '',
      incomeDerivedFromSaleOfCommercialProperties: '',
      incomeDerivedFromSales: false,
      emailPolicy: true,
      professionalAssociation: null,
      professionalAssociationDetails: '',
      noPriorCoverage: null,


      // Page 2
      // 10
      // Residential Sales
      lastRevenueResidentialSales: 0,
      lastNumberResidentialSales: 0,
      nextRevenueResidentialSales: 0,
      nextNumberResidentialSales: 0,
      // Residential Sales
      lastRevenueResidentialProperty: 0,
      lastNumberResidentialProperty: 0,
      nextRevenueResidentialProperty: 0,
      nextNumberResidentialProperty: 0,
      // Residential Farm*
      lastRevenueResidentialFarm: 0,
      lastNumberResidentialFarm: 0,
      nextRevenueResidentialFarm: 0,
      nextNumberResidentialFarm: 0,
      // Owned Residential Raw
      lastRevenueOwnedResidentialRaw: 0,
      lastNumberOwnedResidentialRaw: 0,
      nextRevenueOwnedResidentialRaw: 0,
      nextNumberOwnedResidentialRaw: 0,

      // Owned Residential Appraisals
      lastRevenueOwnedResidentialAppraisals: 0,
      lastNumberOwnedResidentialAppraisals: 0,
      nextRevenueOwnedResidentialAppraisals: 0,
      nextNumberOwnedResidentialAppraisals: 0,

      // Residential Sales
      lastRevenueCommercialSales: 0,
      lastNumberCommercialSales: 0,
      nextRevenueCommercialSales: 0,
      nextNumberCommercialSales: 0,

      // Residential Sales
      lastRevenueCommercialProperty: 0,
      lastNumberCommercialProperty: 0,
      nextRevenueCommercialProperty: 0,
      nextNumberCommercialProperty: 0,

      // Commercial Farm*
      lastRevenueCommercialFarm: 0,
      lastNumberCommercialFarm: 0,
      nextRevenueCommercialFarm: 0,
      nextNumberCommercialFarm: 0,
      // Owned Commercial Raw
      lastRevenueOwnedCommercialRaw: 0,
      lastNumberOwnedCommercialRaw: 0,
      nextRevenueOwnedCommercialRaw: 0,
      nextNumberOwnedCommercialRaw: 0,

      // Owned Commercial Appraisals
      lastRevenueOwnedCommercialAppraisals: 0,
      lastNumberOwnedCommercialAppraisals: 0,
      nextRevenueOwnedCommercialAppraisals: 0,
      nextNumberOwnedCommercialAppraisals: 0,

      // Property Management
      lastRevenuePropertyManagement: 0,
      lastNumberPropertyManagement: 0,
      nextRevenuePropertyManagement: 0,
      nextNumberPropertyManagement: 0,
      // Sale of Business Opportunities
      lastRevenueSalesOfBusiness: 0,
      lastNumberSalesOfBusiness: 0,
      nextRevenueSalesOfBusiness: 0,
      nextNumberSalesOfBusiness: 0,
      // Mortgage Brokering
      lastRevenueMortgageBrokering: 0,
      lastNumberMortgageBrokering: 0,
      nextRevenueMortgageBrokering: 0,
      nextNumberMortgageBrokering: 0,

      // Real Auctioneering
      lastRevenueAuctioneering: 0,
      lastNumberAuctioneering: 0,
      nextRevenueAuctioneering: 0,
      nextNumberAuctioneering: 0,


      // Real Short term Escrow

      lastRevenueShortTermEscrow: 0,
      lastNumberShortTermEscrow: 0,
      nextRevenueShortTermEscrow: 0,
      nextNumberShortTermEscrow: 0,


      // Real Estate Consulting
      lastRevenueRealEstateConsulting: 0,
      lastNumberRealEstateConsulting: 0,
      nextRevenueRealEstateConsulting: 0,
      nextNumberRealEstateConsulting: 0,
      // Other
      lastRevenueOther: 0,
      lastNumberOther: 0,
      nextRevenueOther: 0,
      nextNumberOther: 0,

      // Details of Real Estate Consulting and Other from above
      detailsOfRealEstate1: '',
      detailsOfRealEstate2: '',
      detailsOfRealEstate3: '',

      // Supplemental Appraiser Qustions
      supplementalAppraiserQuestionOne: null,
      supplementalAppraiserQuestionTwo: null,
      supplementalAppraiserQuestionThree: null,
      supplementalAppraiserQuestionThreeRevenue: '',
      supplementalAppraiserQuestionThreeTransactions: '',

      // 11
      doesApplicantHaveDocumentedProcedures: null,

      // 12
      doesApplicantUseApprovedBoardOfRealtors: null,
      haveAnyCommercialOffice: null,
      doesApplicantUseApprovedBoardOfRealtorsDetails: '',

      // Page 3
      // 13

      averageValueOfPropertiesSoldByApplicant: '',
      averageValueOfPropertiesAppraisedByApplicant: '',

      // 14
      signedPropertyDisclosureForm: '',
      homeInspectionOrWrittenWaiver: '',
      homeWarrantyProgram: '',

      // 15
      transactionInvolveActingDualAgent: '',
      transactionInvolveActingIntermediary: '',
      transactionInvolveActingBroker: '',

      // 16
      hasAnyMemberInvolvedInPropertyPreservation: null,

      // 17
      hasAnyMemberInvolvedInPropertyRehabilitation: null,
      wereAllRepairsContractedByLicensed: null,

      // 18
      doYouHaveAdvisedBuyerForPropertyInspection: null,

      // 19
      hasAnyMemberEngagedInAcquiringProperties: null,

      // 20
      hasApplicantEngagedInAnyEviction: null,

      wasPreparationEvictionJudgmentHandledByAttorney: null,

      // 21
      clientResponsibleForMoreThan25PercentAnnualIncome: null,

      // 22
      doesFirmPerformSyndication: null,
      grossCommissionIncomeByFirmPerformSyndications: '',

      // 23
      duringFiveYearsApplicantInvolvedInMerger: null,
      duringFiveYearsApplicantHasPrincipal: null,
      // 24
      doesApplicantControlBusinessInMultipleStates: null,

      // 25
      whomInsuranceApplyClaimMadeBy: null,
      whomInsuranceApplyActOrOmissions: null,
      whomInsuranceApplyToComplaint: null,
      whomInsuranceApplyToReportedChanges: null,

      // Page 4
      // 26
      doesApplicantInsuranceDeclined: null,

      // 27
      firstCompany: '',
      firstPolicyPeriod: '',
      firstLimitOfLiability: '',
      firstDeductible: '',
      firstPremium: '',
      firstRetroDate: '',

      secondCompany: '',
      secondPolicyPeriod: '',
      secondLimitOfLiability: '',
      secondDeductible: '',
      secondPremium: '',
      secondRetroDate: '',

      thirdCompany: '',
      thirdPolicyPeriod: '',
      thirdLimitOfLiability: '',
      thirdDeductible: '',
      thirdPremium: '',
      thirdRetroDate: '',

      fourthCompany: '',
      fourthPolicyPeriod: '',
      fourthLimitOfLiability: '',
      fourthDeductible: '',
      fourthPremium: '',
      fourthRetroDate: '',

      fifthCompany: '',
      fifthPolicyPeriod: '',
      fifthLimitOfLiability: '',
      fifthDeductible: '',
      fifthPremium: '',
      fifthRetroDate: '',

      // 28
      hasApplicantEverPurchasedReporting: null,
      hasApplicantEverPurchasedReportingDetails: '',

      // 29
      limitOfCoverage: '1M/1M',
      deductible: '5000',
      limitsOfLiabilityPerClaim: '',
      limitsOfLiabilityPolicyAggregate: '',
      // claimExpenseInside: false,
      // claimExpenseOutside: false,

      // firstDollarDefense: null,
      // aggregateDeductible: null,

      effectiveDate: null,
      retroactiveDate: null,

      // Page 5
      appraiserEsignatureDatetime: moment().format('YYYY-MM-DD'),
      appraiserPrincipleEsignature: null,
      nameForFraudWarning: null,
      titleForFraudWarning: null,
      signatureForStateMoWy: '',
      nameForStateMoWy: '',
      titleForStateMoWy: '',
      applicantRequestFrom: '',
      realEstateAgentBroker: false,
      slDisclosureSignature: '',
      clientSignature: '',
      hearAboutUs: undefined,
      hearAboutUsOtherDetails: '',
      nklSignature: '',

    },
    pageSlDisclosureIsValid: false,
    effectiveDateValid: false,
    retroactiveDateValid: false,
    pageOneIsValid: false,
    pageTwoIsValid: false,
    pageThreeIsValid: false,
    pageFourIsValid: false,
    pageFiveIsValid: false,
    pageSixIsValid: false,
    pageSevenIsValid: false,
    pageEightIsValid: false,
    emailPolicy: true,
    errorMsg: null,
  },
  actions: {
    createStandardApplication({ state }) {
      state.errorMsg = null;
      Functions.xapi()
        .post('api/standard-application/', {
          ...Functions.snakeCaseKeys(state.standardApplication),
          effective_date: moment(state.standardApplication.effectiveDate).format('YYYY-MM-DD'),
          retroactive_date: moment(state.standardApplication.retroactiveDate).format('YYYY-MM-DD'),
        })
        .then((res) => {
          // eslint-disable-next-line no-unused-vars
          let page = '';
          if (state.standardApplication.customer.state === 'MA') {
            page = 'standard-application-ma-sl-disclosure';
          } else if (state.standardApplication.customer.state === 'CT') {
            page = 'standard-application-ct-sl-disclosure';
          } else if (state.standardApplication.customer.state === 'NY') {
            page = 'standard-application-ny-notice-of-excess';
          } else {
            page = 'standard-application-representation';
          }
          router.push({
            name: page,
          });
        })
        .catch((error) => {
          const firstErrorMsg = (res) => {
            if (!Array.isArray(res)) {
              if (typeof res === 'object') {
                firstErrorMsg(res[Object.keys(res)[0]]);
              } else {
                return 'Server Error';
              }
            } else {
              state.errorMsg = res[0];
            }
          };

          firstErrorMsg(error.response.data);
        });
    },
    createCustomer({ state }) {
      state.errorMsg = null;
      Functions.xapi()
        .post('api/customer/create-customer/', {
          ...Functions.snakeCaseKeys({
            ...state.standardApplication.customer, // disable this checkbox
          }),
          // desired_coverage: COVERAGES.filter(coverage => state.quote.desiredCoverage.find(ele => ele === coverage)),
        })
        .then((res) => {
          state.standardApplication.customer.actContactId = Functions.convertObjectKeyToCamelCase(res.data).actContactId;
          Functions.trackWhatConvertsLead(state.standardApplication.customer);
          router.push({
            name: 'standard-application-2',
          });
        })
        .catch((error) => {
          const firstErrorMsg = (res) => {
            if (!Array.isArray(res)) {
              if (typeof res === 'object') {
                firstErrorMsg(res[Object.keys(res)[0]]);
              } else {
                return 'Server Error';
              }
            } else {
              state.errorMsg = res[0];
            }
          };

          firstErrorMsg(error.response.data);
        });
    },
    createSlDisclosure({ state }) {
      state.errorMsg = null;
      Functions.xapi()
          .post('api/standard-application/create-sl-disclosure/', {
            ...Functions.snakeCaseKeys(state.standardApplication),
            effective_date: moment(state.standardApplication.effectiveDate).format('YYYY-MM-DD'),
            retroactive_date: moment(state.standardApplication.retroactiveDate).format('YYYY-MM-DD'),
          })
          .then((res) => {
            router.push({
              name: 'standard-application-representation',
            });
          })
          .catch((error) => {
            const firstErrorMsg = (res) => {
              if (!Array.isArray(res)) {
                if (typeof res === 'object') {
                  firstErrorMsg(res[Object.keys(res)[0]]);
                } else {
                  return 'Server Error';
                }
              } else {
                state.errorMsg = res[0];
              }
            };

            firstErrorMsg(error.response.data);
          });
    },
  },
};
// export default
const piApplicationModule = {
  namespaced: true,
  state: {
    piApplication: {
      // page 1
      // 1
      nameOfApplicant: '',
      customer: {
        actContactId: '',
        address: '',
        city: '',
        state: '',
        zipCode: '',
        phone: '',
        email: '',
        contactName: '',
        companyName: '',
        fax: '',
        isPiApplication: '',
        appStatus: 1,
        partnerName: '',
      },
      contact: '',
      street: '',
      numberOfFullTimeEmployees: '',
      numberOfPartTimeEmployees: '',
      dateFirmEstablished: '',
      licenseNumber: '',
      applicantOwnership: null,
      effectiveDateFrom: null,
      effectiveDateTo: null,

      annualRevenueSales: 0,
      annualPayroll: 0,
      amountPaid: 0,

      narcoticsSurveillance: undefined,
      autoRepossession: undefined,
      bodyguardProtection: undefined,
      storeDetective: undefined,
      polygraphExam: undefined,
      foreclosureSales: undefined,
      bankAccountSearches: undefined,

      assetSearches: undefined,
      onlineSearches: undefined,
      accidentReconstruction: undefined,
      arsonInspections: undefined,
      attorneyInvestigations: undefined,
      fraudInvestigations: undefined,
      locateWitnesses: undefined,
      domesticSurveillance: undefined,

      undercoverOperatives: undefined,
      guardService: undefined,
      processService: undefined,
      subpoenaService: undefined,
      preemploymentBackgrounds: undefined,
      electronicCountermeasures: undefined,
      otherDescribe: undefined,

      employeesCarryFirearm: undefined,

      employeesCarryFirearmLisensed: undefined,


      additionalInsuredsIndividual: undefined,
      additionalInsuredsBlanket: undefined,
      additionalInsuredsPerProjectAggregate: undefined,
      additionalInsuredsStopGap: undefined,


      waiverSubrogationIndividual: undefined,
      waiverSubrogationBlanket: undefined,
      waiverSubrogationPerProjectAggregate: undefined,

      primaryWordingIndividual: undefined,
      primaryWordingBlanket: undefined,
      primaryWordingPerProjectAggregate: undefined,


      noticeApplicantName: '',
      noticeApplicantSignature: '',

      noticeProducerName: '',
      noticeProducerSignature: '',
      noticeProducerLicense: '',
      applicantRequestFrom: '',
      hearAboutUs: undefined,
      hearAboutUsOtherDetails: ''
    },
    clientSignature: '',
    effectiveDateFromValid: false,
    effectiveDateToValid: false,
    pageOneIsValid: false,
    pageTwoIsValid: false,
    errorMsg: null,
    requestFinancingPaymentLinkWithOutCyberTechnology: '',
    requestFinancingPaymentLinkWithCyberTechnology: '',
  },
  actions: {
    createPiApplication({ state }) {
      state.errorMsg = null;
      Functions.xapi()
        .post('api/pi-application/', {
          ...Functions.snakeCaseKeys(state.piApplication),
          effective_date_from: moment(state.piApplication.effectiveDateFrom).format('YYYY-MM-DD'),
          effective_date_to: moment(state.piApplication.effectiveDateTo).format('YYYY-MM-DD'),
        })
        .then((res) => {
          router.push({
            name: 'pi-application-representation',
          });
        })
        .catch((error) => {
          const firstErrorMsg = (res) => {
            if (!Array.isArray(res)) {
              if (typeof res === 'object') {
                firstErrorMsg(res[Object.keys(res)[0]]);
              } else {
                return 'Server Error';
              }
            } else {
              state.errorMsg = res[0];
            }
          };

          firstErrorMsg(error.response.data);
        });
    },
    createCustomer({ state }) {
      state.errorMsg = null;
      Functions.xapi()
        .post('api/customer/create-customer/', {
          ...Functions.snakeCaseKeys({
            ...state.piApplication.customer, // disable this checkbox
          }),
          // desired_coverage: COVERAGES.filter(coverage => state.quote.desiredCoverage.find(ele => ele === coverage)),
        })
        .then((res) => {
          state.piApplication.customer.actContactId = Functions.convertObjectKeyToCamelCase(res.data).actContactId;
          Functions.trackWhatConvertsLead(state.piApplication.customer);
          router.push({
            name: 'pi-application-2',
          });
        })
        .catch((error) => {
          const firstErrorMsg = (res) => {
            if (!Array.isArray(res)) {
              if (typeof res === 'object') {
                firstErrorMsg(res[Object.keys(res)[0]]);
              } else {
                return 'Server Error';
              }
            } else {
              state.errorMsg = res[0];
            }
          };

          firstErrorMsg(error.response.data);
        });
    },

  },
};

const quickQuoteModule = {
  namespaced: true,
  state: {
    quickQuote: {
      // page 1
      // 1
      nameOfFirm: '',
      customer: {
        actContactId: '',
        address: '',
        city: '',
        state: '',
        zipCode: '',
        phone: '',
        email: '',
        contactName: '',
        companyName: '',
        fax: '',
        isQuickQuoteApplication: '',
        appStatus: 1,
        partnerName: '',
      },
      homeInspectingExperience: undefined,
      expectedAnnualRevenue: 0,
      doYouUseLimitationOfLiability: '',
      memberOfLicensedProfessional: undefined,
      anyClaimsInLastFiveYears: '',
      desiredCoverage: [],
      coverage: 0,
      hearAboutUs: undefined,
      hearAboutUsOtherDetails: ''

    },
    coverages: [],
    effectiveDateFromValid: false,
    effectiveDateToValid: false,
    pageOneIsValid: false,
    pageTwoIsValid: false,
    errorMsg: null,
  },
  actions: {
    createQuickQuote({ state }) {
      state.errorMsg = null;
      Functions.xapi()
          .post('api/quick-quote/', {
            ...Functions.snakeCaseKeys(state.quickQuote),
          })
          .then((res) => {
            state.coverages = Functions.convertObjectKeyToCamelCase(res.data).coverages;
            router.push({
              name: 'quick-quote-representation',
            });
          })
          .catch((error) => {
            const firstErrorMsg = (res) => {
              if (!Array.isArray(res)) {
                if (typeof res === 'object') {
                  firstErrorMsg(res[Object.keys(res)[0]]);
                } else {
                  return 'Server Error';
                }
              } else {
                state.errorMsg = res[0];
              }
            };

            firstErrorMsg(error.response.data);
          });
    },
    createCustomer({ state }) {
      state.errorMsg = null;
      Functions.xapi()
          .post('api/customer/create-customer/', {
            ...Functions.snakeCaseKeys({
              ...state.quickQuote.customer, // disable this checkbox
            }),
            // desired_coverage: COVERAGES.filter(coverage => state.quote.desiredCoverage.find(ele => ele === coverage)),
          })
          .then((res) => {
            state.quickQuote.customer.actContactId = Functions.convertObjectKeyToCamelCase(res.data).actContactId;
            Functions.trackWhatConvertsLead(state.quickQuote.customer);
            router.push({
              name: 'quick-quote-2',
            });
          })
          .catch((error) => {
            const firstErrorMsg = (res) => {
              if (!Array.isArray(res)) {
                if (typeof res === 'object') {
                  firstErrorMsg(res[Object.keys(res)[0]]);
                } else {
                  return 'Server Error';
                }
              } else {
                state.errorMsg = res[0];
              }
            };

            firstErrorMsg(error.response.data);
          });
    },

  },
};

const sipApplicationModule = {
  namespaced: true,
  state: {
    sipApplication: {
      // page 1
      // 1
      nameOfApplicant: '',
      businessEntityType: null,
      website: '',
      customer: {
        actContactId: '',
        address: '',
        city: '',
        state: '',
        zipCode: '',
        phone: '',
        email: '',
        contactName: '',
        companyName: '',
        fax: '',
        isSipApplication: '',
        appStatus: 1,
        partnerName: '',
      },
      businessPhone: '',
      mailingAddress: '',
      mailingCity: '',
      mailingState: '',
      mailingZipCode: '',
      federalId: '',
      dateEstablished: '',
      yearsExperience: '',
      listMembershipAndCertifications: '',

      apia: undefined,
      cali: undefined,
      tali: undefined,
      fapi: undefined,

      nafi: undefined,
      napps: undefined,
      ncapi: undefined,
      nciss: undefined,

      fali: undefined,
      pali: undefined,
      ppiac: undefined,
      piai: undefined,

      piava: undefined,
      pasco: undefined,
      scali: undefined,

      accidentReconstruction: 0,
      accountingForensic: 0,
      arsonPropertyInvestigations: 0,
      attorneyLegalInvestigations: 0,
      backgroundInvestigations: 0,
      computerForensic: 0,
      conservatorOfPeace: 0,
      constableServices: 0,
      consulting: 0,
      copyrightTrademarkInvestigations: 0,
      cyberSecurityInfiltration: 0,
      other: 0,

      debuggingTscm: 0,
      executiveProtection: 0,
      exitingInterview: 0,
      expertWitnessServices: 0,
      fidelityInvestigations: 0,
      fingerprintAnalysis: 0,
      firearmsTrainingClassRoom: 0,
      firearmsTrainingRange: 0,
      genealogy: 0,
      insuranceInvestigations: 0,
      juvenileInvestigations: 0,

      kidnapAndRamson: 0,
      lieDetectionPolygraph: 0,
      locateSkipTrace: 0,
      mortgageCourtAuctionServices: 0,
      onlineSearches: 0,
      processServiceSubpoena: 0,
      securityTraining: 0,
      shoppingServicesMysteryShopping: 0,
      subRosaInvestigations: 0,
      threatVulnerabilityAssessment: 0,
      underCoverInvestigations: 0,
      percentageOther: '',

      expectedAnnualRevenue: 0,
      limitsOfLiability: [],
      personalPropertyCoverage: [],

      businessIncomeAndExtraExpense: true,
      totalNumberOfEmployees: '',
      numberOfInvestigators: '',

      doesApplicantSubcontract: undefined,

      percentageOfWorkSubcontracted: '',

      subcontractorsRequireToMaintainLiability: undefined,
      annualPayroll: '',
      yearsMaintainedContinuousGeneralLiability: '',
      nameOfPriorInsurance: '',
      policyPeriod: '',
      maintainedLimit: '',
      maintainedDeductible: '',
      maintainedPremium: '',
      claimMadeInPast5Years: undefined,

      applicantAwareOfAnyCircumstance: undefined,
      insurerCanceledRefused5Years: undefined,
      useOfFirm: undefined,
      licensedPrivateInvestigator: undefined,

      hireLimitLiability: [],

      commercialAutoPolicyInPlace: undefined,

      doesApplicantRentOrHireAuto10Time: undefined,
      doesApplicantUseAnyAuto: undefined,
      doesApplicantOwnAnyAuto: undefined,


      blanketAdditionalInsured: true,
      privateEyeEndorsement: true,
      waiverOfSubrogation: undefined,
      primaryWording: undefined,
      noseCoverage: undefined,

      worldwideCoverage: undefined,
      doesApplicantHaveKnowledgeAlleged: undefined,

      cyberPrivacyCrimeCoverage: undefined,
      workersCompensation: undefined,
      suretyLicenseBonds: undefined,
      commercialAuto: undefined,
      directorsAndOfficersLiability: undefined,
      employeePracticeLiability: undefined,
      droneUnmannedAircraftLiability: undefined,

      nameForWarrantyStatement: '',
      signatureForWarrantyStatement: '',
      effectiveDate: null,
      retroactiveDate: null,

      appraiserEsignatureDatetime: moment().format('YYYY-MM-DD'),
      appraiserPrincipleEsignature: null,
      clientSignature: '',
      applicantRequestFrom: '',

    },
    coverage: 0,
    coverages: [],
    showPricing: false,
    effectiveDateValid: false,
    retroactiveDateValid: false,
    pageOneIsValid: false,
    pageTwoIsValid: false,
    pageThreeIsValid: false,
    pageFourIsValid: true,
    pageFiveIsValid: false,
    errorMsg: null,
  },
  actions: {
    createSipApplication({ state }) {
      state.errorMsg = null;
      Functions.xapi()
        .post('api/sip-application/', {
          ...Functions.snakeCaseKeys(state.sipApplication),
          effective_date: moment(state.sipApplication.effectiveDate).format('YYYY-MM-DD'),
          retroactive_date: moment(state.sipApplication.retroactiveDate).format('YYYY-MM-DD'),
        })
        .then((res) => {
          state.coverages = Functions.convertObjectKeyToCamelCase(res.data).coverages;
          state.showPricing = Functions.convertObjectKeyToCamelCase(res.data).showPricing;
          router.push({
            name: 'sip-application-representation',
          });
        })
        .catch((error) => {
          const firstErrorMsg = (res) => {
            if (!Array.isArray(res)) {
              if (typeof res === 'object') {
                firstErrorMsg(res[Object.keys(res)[0]]);
              } else {
                return 'Server Error';
              }
            } else {
              state.errorMsg = res[0];
            }
          };

          firstErrorMsg(error.response.data);
        });
    },
    createCustomer({ state }) {
      state.errorMsg = null;
      Functions.xapi()
        .post('api/customer/create-customer/', {
          ...Functions.snakeCaseKeys({
            ...state.sipApplication.customer, // disable this checkbox
          }),
          // desired_coverage: COVERAGES.filter(coverage => state.quote.desiredCoverage.find(ele => ele === coverage)),
        })
        .then((res) => {
          state.sipApplication.customer.actContactId = Functions.convertObjectKeyToCamelCase(res.data).actContactId;
          Functions.trackWhatConvertsLead(state.sipApplication.customer);
          router.push({
            name: 'sip-application-2',
          });
        })
        .catch((error) => {
          const firstErrorMsg = (res) => {
            if (!Array.isArray(res)) {
              if (typeof res === 'object') {
                firstErrorMsg(res[Object.keys(res)[0]]);
              } else {
                return 'Server Error';
              }
            } else {
              state.errorMsg = res[0];
            }
          };

          firstErrorMsg(error.response.data);
        });
    },

  },
};

const ppiApplicationModule = {
  namespaced: true,
  state: {
    ppiApplication: {
      // page 1
      // 1
      nameOfApplicant: '',
      website: '',
      customer: {
        actContactId: '',
        address: '',
        city: '',
        state: '',
        zipCode: '',
        phone: '',
        email: '',
        contactName: '',
        companyName: '',
        fax: '',
        isPpiApplication: '',
        appStatus: 1,
        partnerName: '',
      },
      checkIfMailAddressSame: false,
      mailingAddress: '',
      mailingCity: '',
      mailingState: '',
      mailingZipCode: '',
      dateEstablished: '',
      limitsOfLiability: [],
      yearsExperience: '',

      executiveProtection: 0,
      backgroundInvestigations: 0,
      attorneyLegalInvestigations: 0,
      arsonPropertyInvestigations: 0,
      computerForensic: 0,
      accountingForensic: 0,
      fidelityInvestigations: 0,
      nflConsulting: 0,
      other: 0,

      processServiceSubpoena: 0,
      consulting: 0,
      copyrightTrademarkInvestigations: 0,
      locateSkipTrace: 0,
      debuggingTscm: 0,
      accidentReconstruction: 0,
      exitingInterview: 0,
      surveillance: 0,

      insuranceInvestigations: 0,
      fingerprintAnalysis: 0,
      firearmsTrainingClassRoom: 0,
      firearmsTrainingRange: 0,
      genealogy: 0,
      securityTraining: 0,
      juvenileInvestigations: 0,
      underCoverInvestigations: 0,
      percentageOther: '',

      totalNumberOfEmployees: '',
      expectedAnnualRevenue: 0,
      annualPayroll: '',
      doesApplicantSubcontract: undefined,
      amountPaidToSubcontractors: '',
      subcontractorsLiabilityCoverage: '',
      haveLiabilityInsurance: undefined,
      policyExpireDate: null,
      claimMadeInPast5Years: undefined,
      applicantAwareOfAnyCircumstance: undefined,
      insurerCanceledRefused5Years: undefined,
      useOfFirm: undefined,
      listOfProfessionalAssociations: 'None',
      waiverOfSubrogation: undefined,
      cyberTechnologyCoverage: false,
      primaryWording: undefined,
      worldwideCoverage: undefined,
      commercialAutoPolicyInPlace: undefined,
      doesApplicantRentOrHireAuto10Time: undefined,
      doesApplicantUseAnyAuto: undefined,
      doesApplicantOwnAnyAuto: undefined,
      hireLimitLiability: [],

      effectiveDate: null,
      retroactiveDate: null,

      //Page 3
      appraiserEsignatureDatetime: moment().format('YYYY-MM-DD'),
      appraiserPrincipleEsignature: null,
      nameForFraudWarning: null,
      titleForFraudWarning: null,
      signatureForStateMoWy: '',
      nameForStateMoWy: '',
      titleForStateMoWy: '',
      clientSignature: '',
      applicantRequestFrom: '',
      hearAboutUs: undefined,
      hearAboutUsOtherDetails: '',
      nklSignature: '',
    },
    coverage: 0,
    coverages: [],
    showPricing: false,
    effectiveDateValid: false,
    retroactiveDateValid: false,
    pageOneIsValid: false,
    pageTwoIsValid: false,
    pageThreeIsValid: false,
    pageFourIsValid: true,
    pageFiveIsValid: false,
    errorMsg: null,
  },
  actions: {
    createPpiApplication({ state }) {
      state.errorMsg = null;
      Functions.xapi()
          .post('api/ppi-application/', {
            ...Functions.snakeCaseKeys(state.ppiApplication),
            effective_date: moment(state.ppiApplication.effectiveDate).format('YYYY-MM-DD'),
            policy_expire_date: moment(state.ppiApplication.policyExpireDate).format('YYYY-MM-DD'),
            retroactive_date: moment(state.ppiApplication.retroactiveDate).format('YYYY-MM-DD'),
          })
          .then((res) => {
            state.coverages = Functions.convertObjectKeyToCamelCase(res.data).coverages;
            state.showPricing = Functions.convertObjectKeyToCamelCase(res.data).showPricing;
            state.requestFinancingPaymentLinkWithOutCyberTechnology = res.data.paymentLinkWithOutCyberTechnology;
            state.requestFinancingPaymentLinkWithCyberTechnology = res.data.paymentLinkWithCyberTechnology;

            router.push({
              name: 'ppi-application-representation',
            });
          })
          .catch((error) => {
            const firstErrorMsg = (res) => {
              if (!Array.isArray(res)) {
                if (typeof res === 'object') {
                  firstErrorMsg(res[Object.keys(res)[0]]);
                } else {
                  return 'Server Error';
                }
              } else {
                state.errorMsg = res[0];
              }
            };

            firstErrorMsg(error.response.data);
          });
    },
    createCustomer({ state }) {
      state.errorMsg = null;
      Functions.xapi()
          .post('api/customer/create-customer/', {
            ...Functions.snakeCaseKeys({
              ...state.ppiApplication.customer, // disable this checkbox
            }),
            // desired_coverage: COVERAGES.filter(coverage => state.quote.desiredCoverage.find(ele => ele === coverage)),
          })
          .then((res) => {
            state.ppiApplication.customer.actContactId = Functions.convertObjectKeyToCamelCase(res.data).actContactId;
            Functions.trackWhatConvertsLead(state.ppiApplication.customer);
            router.push({
              name: 'ppi-application-2',
            });
          })
          .catch((error) => {
            const firstErrorMsg = (res) => {
              if (!Array.isArray(res)) {
                if (typeof res === 'object') {
                  firstErrorMsg(res[Object.keys(res)[0]]);
                } else {
                  return 'Server Error';
                }
              } else {
                state.errorMsg = res[0];
              }
            };

            firstErrorMsg(error.response.data);
          });
    },

  },
};

const rcApplicationModule = {
  namespaced: true,
  state: {
    rcApplication: {
      // page 1
      // 1
      namedInsured: '',
      customer: {
        actContactId: '',
        address: '',
        city: '',
        state: '',
        zipCode: '',
        phone: '',
        email: '',
        contactName: '',
        companyName: '',
        fax: '',
        isRcApplication: '',
        appStatus: 1,
        partnerName: '',
      },
      website: '',
      fein: '',
      mailingAddress: '',
      mailingCity: '',
      mailingState: '',
      mailingZipCode: '',
      contactName: '',
      mailingPhone: '',
      yearBusinessStatedFireWater: '',
      numberOfEmployees: '',
      isApplicantGroupMemberSubsidiary: undefined,


      applicantOwnership: null,
      environmentalCombinedPolicy: undefined,
      contractorsPollutionLiability: undefined,
      environmentalConsultantsLiability: undefined,
      contractorsConsultantsPolicy: undefined,

      generalLiabilityNone: undefined,
      contractorsPollutionLiabilityNone: undefined,
      professionalLiabilityNone: undefined,
      generalLiabilityOccurrence: undefined,
      generalLiabilityClaimsMade: undefined,
      contractorsPollutionLiabilityOccurrence: undefined,
      contractorsPollutionLiabilityClaimsMade: undefined,
      professionalLiabilityOccurrence: undefined,
      professionalLiabilityClaimsMade: undefined,

      OccurrenceOrClaim: '',
      aggregate: '',
      deductible: '',
      effectiveDate: null,
      expirationDate: null,

      generalLiabilityCarrier: '',
      contractorsPollutionLiabilityCarrier: '',
      professionalLiabilityCarrier: '',

      generalLiabilityLimits: '',
      contractorsPollutionLiabilityLimits: '',
      professionalLiabilityLimits: '',

      generalLiabilityDeductible: '',
      contractorsPollutionLiabilityDeductible: '',
      professionalLiabilityDeductible: '',

      generalLiabilityPremium: '',
      contractorsPollutionLiabilityPremium: '',
      professionalLiabilityPremium: '',

      generalLiabilityEffectiveDates: '',
      contractorsPollutionLiabilityEffectiveDates: '',
      professionalLiabilityEffectiveDates: '',

      generalLiabilityetroactiveDate: '',
      contractorsPollutionLiabilityetroactiveDate: '',
      professionalLiabilityetroactiveDate: '',

      projectedRevenue: 0,
      projectedPayroll: 0,
      projectedNumberOfEmployees: 0,

      expiringRevenue: 0,
      expiringPayroll: 0,
      expiringNumberOfEmployees: 0,

      firstPriorRevenue: 0,
      firstPriorPayroll: 0,
      firstPriorNumberOfEmployees: 0,

      revenueAsbestosAbatement: 0,
      percentageRevenueAsbestosAbatement: 0,
      payrollAsbestosAbatement: 0,

      revenueCarpetCleaning: 0,
      percentageRevenueCarpetCleaning: 0,
      payrollCarpetCleaning: 0,

      revenueDebrisRemoval: 0,
      percentageRevenueDebrisRemoval: 0,
      payrollDebrisRemoval: 0,

      revenueDuctCleaning: 0,
      percentageRevenueDuctCleaning: 0,
      payrollDuctCleaning: 0,


      revenueLeadAbatement: 0,
      percentageRevenueLeadAbatement: 0,
      payrollLeadAbatement: 0,

      revenueFungusAbatementCommercial: 0,
      percentageRevenueFungusAbatementCommercial: 0,
      payrollFungusAbatementCommercial: 0,

      revenueFungusAbatementResidential: 0,
      percentageRevenueFungusAbatementResidential: 0,
      payrollFungusAbatementResidential: 0,

      revenuePackOuts: 0,
      percentageRevenuePackOuts: 0,
      payrollPackOuts: 0,

      revenueSmoke: 0,
      percentageRevenueSmoke: 0,
      payrollSmoke: 0,

      revenueSewageCleanup: 0,
      percentageRevenueSewageCleanup: 0,
      payrollSewageCleanup: 0,

      revenueTrauma: 0,
      percentageRevenueTrauma: 0,
      payrollTrauma: 0,

      revenueWaterExtraction: 0,
      percentageRevenueWaterExtraction: 0,
      payrollWaterExtraction: 0,

      revenueEnvironmentalOther: 0,
      percentageRevenueEnvironmentalOther: 0,
      payrollEnvironmentalOther: 0,


      revenueCarpentry: 0,
      percentageRevenueCarpentry: 0,
      payrollCarpentry: 0,

      revenueConcrete: 0,
      percentageRevenueConcrete: 0,
      payrollConcrete: 0,


      revenueDemolitionExterior: 0,
      percentageRevenueDemolitionExterior: 0,
      payrollDemolitionExterior: 0,

      revenueDemolitionInterior: 0,
      percentageRevenueDemolitionInterior: 0,
      payrollDemolitionInterior: 0,


      revenueElectrical: 0,
      percentageRevenueElectrical: 0,
      payrollElectrical: 0,

      revenueExcavation: 0,
      percentageRevenueExcavation: 0,
      payrollExcavation: 0,


      revenueFlooring: 0,
      percentageRevenueFlooring: 0,
      payrollFlooring: 0,

      revenueHvac: 0,
      percentageRevenueHvac: 0,
      payrollHvac: 0,


      revenueInsulation: 0,
      percentageRevenueInsulation: 0,
      payrollInsulation: 0,

      revenueMaintenance: 0,
      percentageRevenueMaintenance: 0,
      payrollMaintenance: 0,


      revenueMetalErection: 0,
      percentageRevenueMetalErection: 0,
      payrollMetalErection: 0,

      revenuePainting: 0,
      percentageRevenuePainting: 0,
      payrollPainting: 0,


      revenuePlumbingCommercial: 0,
      percentageRevenuePlumbingCommercial: 0,
      payrollPlumbingCommercial: 0,

      revenuePlumbingResidential: 0,
      percentageRevenuePlumbingResidential: 0,
      payrollPlumbingResidential: 0,


      revenueRoofing: 0,
      percentageRevenueRoofing: 0,
      payrollRoofing: 0,


      revenueSiding: 0,
      percentageRevenueSiding: 0,
      payrollSiding: 0,


      revenueConstructionOther: 0,
      percentageRevenueConstructionOther: 0,
      payrollConstructionOther: 0,

      revenueAnalyticalLaboratories: 0,
      percentageRevenueAnalyticalLaboratories: 0,
      payrollAnalyticalLaboratories: 0,


      revenueAsbestos: 0,
      percentageRevenueAsbestos: 0,
      payrollAsbestos: 0,

      revenueConstructionManagement: 0,
      percentageRevenueConstructionManagement: 0,
      payrollConstructionManagement: 0,

      revenueEnvironmentalConsulting: 0,
      percentageRevenueEnvironmentalConsulting: 0,
      payrollEnvironmentalConsulting: 0,

      revenueMoldFungusCommercial: 0,
      percentageRevenueMoldFungusCommercial: 0,
      payrollMoldFungusCommercial: 0,

      revenueMoldFungusResidential: 0,
      percentageRevenueMoldFungusResidential: 0,
      payrollMoldFungusResidential: 0,

      revenueProfessionalOther: 0,
      percentageRevenueProfessionalOther: 0,
      payrollProfessionalOther: 0,

      environmentalContracting: undefined,
      constructionAndBuildBack: undefined,
      professionalServices: undefined,

      doesFirmHaveWrittenQuality: undefined,
      doesFirmHaveInHouseContinuing: undefined,
      doesFirmHaveInHouseContinuingDetails: '',
      doYouHaveWrittenFormalHealth: undefined,
      doYouEngageInAnyOperations: undefined,
      doYouPerformAirQualityTesting: undefined,

      whatMoldFungusGuidelinesAdhere: '',
      doYouProvideWrittenWarranties: '',
      newConstructionWorkNotAssociatedWithFire: undefined,
      newConstructionWorkNotAssociatedWithFireDetails: '',
      remodelingWorkNotAssociatedWithFire: undefined,
      remodelingWorkNotAssociatedWithFireDetails: '',
      doBuildingOfSingleFamilyHomes: undefined,
      singleFamilyHomes: '',
      multiFamilyHomes: '',
      commericalBlgs: '',
      projectMoreThan25PercentOfAnnual: undefined,
      projectMoreThan25PercentOfAnnualDetails: '',

      numberOfStaffEngineers: 0,
      numberOfStaffAccounts: 0,
      numberOfStaffManagers: 0,
      numberOfStaffAdmin: 0,
      numberOfStaffFieldOther: 0,
      numberOfStaffFieldPersonnel: 0,
      numberOfStaffFieldOtherThanAbove: 0,
      numberOfStaffFieldPrincipals: 0,
      workSubcontractedPercent: 0,
      workSubcontractedOutTo1099: 0,

      hiringSubcontractors: '',
      haveGeneralLiabilityInsurance: undefined,
      haveContractorPollutionLiability: undefined,
      workWithoutProvidingCertificate: undefined,
      additionalInsuredOnTheSubcontractors: undefined,
      signAContractAndObtainWaivers: undefined,
      verifyAllHiredSubContractors: undefined,

      operatatedStateCountry1: '',
      operationsAndServicePerformed1: '',
      percentageOfWorkPerformed1: '',

      operatatedStateCountry2: '',
      operationsAndServicePerformed2: '',
      percentageOfWorkPerformed2: '',

      operatatedStateCountry3: '',
      operationsAndServicePerformed3: '',
      percentageOfWorkPerformed3: '',

      applicantPerformOperationsInNewYork: undefined,
      applicantPerformOperationsInNewYorkDetails: '',
      engageInAnyWorkOutsideUs: undefined,
      engageInAnyWorkOutsideUsDetails: '',

      insuranceCarriersPercent: 0,
      insuranceCarriersContractors: 0,
      directRepairNetworksPercent: 0,
      directRepairNetworksCategory: 0,
      stateOrLocalGovtPercent: 0,
      stateOrLocalGovtCategory: 0,

      typeOfProjectResidential: 0,
      typeOfProjectRetail: 0,
      typeOfProjectOffice: 0,
      typeOfProjectHotels: 0,
      typeOfProjectState: 0,
      typeOfProjectOther: 0,

      packout1800: undefined,
      lionsbridge: undefined,
      waterDamage1800: undefined,
      nexxusSolutions: undefined,
      advantaClean: undefined,
      paulDavisRestoration: undefined,
      alacrity: undefined,
      puroclean: undefined,
      codeBlue: undefined,
      rainbowInternational: undefined,
      crawfordContractor: undefined,
      ria: undefined,
      dki: undefined,
      serviceMaster: undefined,
      icra: undefined,
      servPro: undefined,
      imacc: undefined,
      membershipOther: undefined,

      writtenProcedureForTheScreening: undefined,
      writtenProcedureForTheScreeningDetails: '',
      mvrsPulled: undefined,
      mvrsPulledDetails: '',
      formalDriverQualificationMvr: undefined,
      formalDriverQualificationMvrDetails: '',
      isVehicleMaintenance: undefined,
      isVehicleMaintenanceDetails: '',
      employeesUsePersonalVehicles: undefined,
      employeesUsePersonalVehiclesDetails: '',

      doYouUseOwnerOperators: undefined,
      doYouUseOwnerOperatorsDetails: '',
      doYouAllowEmployeesCompanyVehicles: undefined,

      employeesAllowToTakeVehiclesHome: undefined,
      writtenPolicyRegardingCellPhone: undefined,
      writtenPolicyRegardingCellPhoneDetails: '',

      maxValueOfProperty: '',
      howManyStorageLocations: '',
      typicalNumberOfPackOut: '',
      howManyStorageLocationsIn100Year: '',
      hasApplicantSubjectToClaimDamage: undefined,
      hasApplicantSubjectToClaimDamageDetails: '',

      propertyOfOthersBaileesExposures: [],

      numberOfCompanyOwnedVehicles: 0,
      numberOfDrivers: 0,
      privatePass: 0,
      mediumTrucks: 0,
      lightTrucks: 0,
      heavyTrucks: 0,
      heavyTruckTractors: 0,
      extraHeavyTruck: 0,
      extraHeavyTruckTractors: 0,
      trailers: 0,

      hasAnyInsurerEverCancelled: undefined,
      hasAnyInsurerEverCancelledDetails: '',
      doesApplicantHaveAnySubsidiaries: undefined,
      doesApplicantHaveAnySubsidiariesDetails: '',

      hasApplicantEverBeenBankruptcy: undefined,
      hasApplicantEverBeenBankruptcyDetails: '',
      haveThereAnyMergerConsolidations: undefined,
      haveThereAnyMergerConsolidationsDetails: '',
      hasThisBusinessEverOperatedDifferentName: undefined,
      hasThisBusinessEverOperatedDifferentNameDetails: '',

      significantChangesInOperationsLast12Months: '',

      prosecutedForAnyViolationInPast5Years: undefined,
      prosecutedForAnyViolationInPast5YearsDetails: '',
      anyStatutesThatCannotPresentComply: undefined,
      anyStatutesThatCannotPresentComplyDetails: '',
      haveYouBeenThirdPartyClaim: undefined,
      haveYouBeenThirdPartyClaimDetails: '',

      doYouHaveOutsideContractor: undefined,
      doYouHaveOutsideContractorDetails: '',

      nameOfFirm: '',
      appraiserContact: '',
      appraiserPhoneNumber: '',
      appraiserEmail: '',
      haveAnyClaimsEverBeenMadeAgainstApplicant: undefined,
      haveAnyClaimsEverBeenMadeAgainstApplicantDetails: '',

      areYouAwareAnySituationClaimCoverage: undefined,
      areYouAwareAnySituationClaimCoverageDetails: '',

      hasAnyStaffDisciplinaryAction: undefined,
      hasAnyStaffDisciplinaryActionDetails: '',

      appraiserEsignatureName: '',
      appraiserEsignatureTitle: '',
      appraiserEsignature: '',
      clientSignature: '',
      applicantRequestFrom: '',
      hearAboutUs: undefined,
      hearAboutUsOtherDetails: ''

    },
    effectiveDateValid: false,
    expirationDateValid: false,
    pageOneIsValid: false,
    pageTwoIsValid: false,
    pageThreeIsValid: false,
    pageFourIsValid: false,
    pageFiveIsValid: false,
    pageSixIsValid: false,
    errorMsg: null,
  },
  actions: {
    createRcApplication({ state }) {
      state.errorMsg = null;
      Functions.xapi()
        .post('api/rc-application/', {
          ...Functions.snakeCaseKeys(state.rcApplication),
          effective_date: moment(state.rcApplication.effectiveDate).format('YYYY-MM-DD'),
          expiration_date: moment(state.rcApplication.expirationDate).format('YYYY-MM-DD'),
        })
        .then((res) => {
          router.push({
            name: 'rc-application-representation',
          });
        })
        .catch((error) => {
          const firstErrorMsg = (res) => {
            if (!Array.isArray(res)) {
              if (typeof res === 'object') {
                firstErrorMsg(res[Object.keys(res)[0]]);
              } else {
                return 'Server Error';
              }
            } else {
              state.errorMsg = res[0];
            }
          };

          firstErrorMsg(error.response.data);
        });
    },
    createCustomer({ state }) {
      state.errorMsg = null;
      Functions.xapi()
        .post('api/customer/create-customer/', {
          ...Functions.snakeCaseKeys({
            ...state.rcApplication.customer, // disable this checkbox
          }),
          // desired_coverage: COVERAGES.filter(coverage => state.quote.desiredCoverage.find(ele => ele === coverage)),
        })
        .then((res) => {
          state.rcApplication.customer.actContactId = Functions.convertObjectKeyToCamelCase(res.data).actContactId;
          Functions.trackWhatConvertsLead(state.rcApplication.customer);
          router.push({
            name: 'rc-application-2',
          });
        })
        .catch((error) => {
          const firstErrorMsg = (res) => {
            if (!Array.isArray(res)) {
              if (typeof res === 'object') {
                firstErrorMsg(res[Object.keys(res)[0]]);
              } else {
                return 'Server Error';
              }
            } else {
              state.errorMsg = res[0];
            }
          };

          firstErrorMsg(error.response.data);
        });
    },

  },
};

const insuranceAgentApplicationModule = {
  namespaced: true,
  state: {
    insuranceAgentApplication: {
      // page 1
      // 1
      nameOfApplicant: '',
      businessName: '',
      customer: {
        actContactId: '',
        address: '',
        city: '',
        state: '',
        zipCode: '',
        phone: '',
        email: '',
        contactName: '',
        companyName: '',
        fax: '',
        isInsuranceAgentApplication: '',
        appStatus: 1,
        partnerName: '',
      },
      checkIfMailAddressSame: false,
      mailingAddress: '',
      mailingCity: '',
      mailingState: '',
      mailingZipCode: '',
      website: '',

      // 6
      applicantOwnership: null,

      // 7
      dateAgencyEstablished: '',

      // 8
      businessOutsideHome: null,
      haveYouLicensedEveryState: null,
      statesWriteBusiness: '',
      // 9
      haveMoreThanOneOffice: null,

      // 10
      ownershipNameOne: '',
      ownershipOne: '',
      ownershipActiveOne: undefined,
      ownershipTitleOne: '',
      ownershipExperienceOne: '',

      ownershipNameTwo: '',
      ownershipTwo: '',
      ownershipActiveTwo: undefined,
      ownershipTitleTwo: '',
      ownershipExperienceTwo: '',

      ownershipNameThree: '',
      ownershipThree: '',
      ownershipActiveThree: undefined,
      ownershipTitleThree: '',
      ownershipExperienceThree: '',

      ownershipNameFour: '',
      ownershipFour: '',
      ownershipActiveFour: undefined,
      ownershipTitleFour: '',
      ownershipExperienceFour: '',

      ownershipNameFive: '',
      ownershipFive: '',
      ownershipActiveFive: undefined,
      ownershipTitleFive: '',
      ownershipExperienceFive: '',

      //page-2

      // 10A
      threeYearsExperience: '',

      // 11
      nonEmployeesFulltime: 0,
      nonEmployeesParttime: 0,

      // 12
      periodOne: 0,
      periodTwo: 0,
      estimateCommissionEarnOne: 0,
      estimateCommissionEarnTwo: 0,

      // 13
      commercialFire: 0,
      commercialGeneral: 0,
      nonArtisanContractors: 0,
      commercialAutoGarage: 0,
      truckingLongHaul: 0,
      workersComp: 0,
      bop: 0,
      professionalLiability: 0,
      oceanMarine: 0,
      aviation: 0,
      surety: 0,
      bondsOtherThanSurety: 0,
      homeowners: 0,
      personalAuto: 0,
      personalFloaters: 0,
      lifeAccident: 0,
      otherExplain: 0,

      // 14
      otherBusinessThanInsurance: null,
      programManager: null,
      programManagerRevenue: '',
      managingGeneralAgent: null,
      managingGeneralAgentRevenue: '',
      taxServices: null,
      taxServicesRevenue: '',

      bookKeeping: null,
      bookKeepingRevenue: '',

      adjustingClaims: null,
      adjustingClaimsRevenue: '',

      registeredInvestment: null,
      registeredInvestmentRevenue: '',

      engagedOtherServices: null,
      engagedOtherServicesRevenue: '',

      //page 3
      // 15
      businessCompanyNameOne: '',
      businessPercentageOne: '',
      businessAdmittedOne: undefined,

      businessCompanyNameTwo: '',
      businessPercentageTwo: '',
      businessAdmittedTwo: undefined,

      businessCompanyNameThree: '',
      businessPercentageThree: '',
      businessAdmittedThree: undefined,

      businessCompanyNameFour: '',
      businessPercentageFour: '',
      businessAdmittedFour: undefined,

      businessCompanyNameFive: '',
      businessPercentageFive: '',
      businessAdmittedFive: undefined,

      businessCompanyNameSix: '',
      businessPercentageSix: '',
      businessAdmittedSix: undefined,

      businessCompanyNameSeven: '',
      businessPercentageSeven: '',
      businessAdmittedSeven: undefined,

      businessCompanyNameEight: '',
      businessPercentageEight: '',
      businessAdmittedEight: undefined,
      // 16
      insuranceNetwork: null,
      insuranceNetworkDetails: '',
      // 17
      ownOtherFirm: null,
      ownOtherFirmDetails: '',

      // 18
      past3YearsAgencyNameChanged: null,
      past3YearsAgencyNameChangedDetails: '',
      // 19
      acceptBusinessFromOtherAgents: null,
      acceptBusinessFromOtherAgentsDetails: '',

      // 20
      incomingMailStamped: null,
      // 21
      howLongMaintainRecords: '',
      // 22
      maintainBinderLog: null,
      // 23
      documentAllBusinessConversations: null,
      // 24
      coverageChangeRequest: null,
      // 25
      acknowledgeDisaster: null,
      // 26
      doYouUsePowerOfAttorney: null,
      // 27

      withdrawnFromAgencyLast3Years: null,
      withdrawnFromAgencyLast3YearsDetails: '',
      // 28
      haveBindingAuthority: null,
      haveBindingAuthorityDetails: '',
      // 29
      eoCoverage: null,
      // 30
      insuranceRenewalCancelled: null,
      insuranceRenewalCancelledDetails: '',

      //page-4
      // 31
      subjectToDisciplinaryAction: null,
      subjectToDisciplinaryActionDetails: '',
      // 32
      suitsAgaintsApplicantInLast5Years: null,
      suitsAgaintsApplicantInLast5YearsDetails: '',

      // 33
      claimMadeAgainstApplicant: null,
      claimMadeAgainstApplicantDetails: '',

      //34
      effectiveDate: null,
      //35
      desiredCoverage: [],
      desiredCoverageCustomLimit: '',
      deductible: '5000',
      deductibleCustomLimit: '',

      // page 5
      nklTitle: '',
      nklName: '',
      nklSignature: '',

      // Page 6
      appraiserEsignatureDatetime: moment().format('YYYY-MM-DD'),
      nameForFraudWarning: null,
      titleForFraudWarning: null,
      clientSignature: '',
      emailPolicy: true,
      applicantRequestFrom: '',
      hearAboutUs: undefined,
      hearAboutUsOtherDetails: '',
    },
    effectiveDateValid: false,
    retroactiveDateValid: false,
    pageOneIsValid: false,
    pageTwoIsValid: false,
    pageThreeIsValid: false,
    pageFourIsValid: false,
    pageFiveIsValid: false,
    pageSixIsValid: false,
    errorMsg: null,
  },
  actions: {
    createInsuranceAgentApplication({ state }) {
      state.errorMsg = null;
      Functions.xapi()
          .post('api/ibdpro-insurance-agent-application/', {
            ...Functions.snakeCaseKeys(state.insuranceAgentApplication),
            effective_date: moment(state.insuranceAgentApplication.effectiveDate).format('YYYY-MM-DD'),
            retroactive_date: moment(state.insuranceAgentApplication.retroactiveDate).format('YYYY-MM-DD'),
          })
          .then((res) => {
            // eslint-disable-next-line no-unused-vars
            let page = '';
              page = 'ibdpro-insurance-agent-application-representation';
            router.push({
              name: page,
            });
          })
          .catch((error) => {
            const firstErrorMsg = (res) => {
              if (!Array.isArray(res)) {
                if (typeof res === 'object') {
                  firstErrorMsg(res[Object.keys(res)[0]]);
                } else {
                  return 'Server Error';
                }
              } else {
                state.errorMsg = res[0];
              }
            };

            firstErrorMsg(error.response.data);
          });
    },
    createCustomer({ state }) {
      state.errorMsg = null;
      Functions.xapi()
          .post('api/customer/create-customer/', {
            ...Functions.snakeCaseKeys({
              ...state.insuranceAgentApplication.customer, // disable this checkbox
            }),
            // desired_coverage: COVERAGES.filter(coverage => state.quote.desiredCoverage.find(ele => ele === coverage)),
          })
          .then((res) => {
            state.insuranceAgentApplication.customer.actContactId = Functions.convertObjectKeyToCamelCase(res.data).actContactId;
            Functions.trackWhatConvertsLead(state.insuranceAgentApplication.customer);
            router.push({
              name: 'ibdpro-insurance-agent-application-2',
            });
          })
          .catch((error) => {
            const firstErrorMsg = (res) => {
              if (!Array.isArray(res)) {
                if (typeof res === 'object') {
                  firstErrorMsg(res[Object.keys(res)[0]]);
                } else {
                  return 'Server Error';
                }
              } else {
                state.errorMsg = res[0];
              }
            };

            firstErrorMsg(error.response.data);
          });
    },
  },
};

const mgaApplicationModule = {
  namespaced: true,
  state: {
    mgaApplication: {
      // page 1
      // 1
      nameOfApplicant: '',
      businessName: '',
      customer: {
        actContactId: '',
        address: '',
        city: '',
        state: '',
        zipCode: '',
        phone: '',
        email: '',
        contactName: '',
        companyName: '',
        fax: '',
        isMgaApplication: '',
        appStatus: 1,
        partnerName: '',
      },
      website: '',
      checkIfNoAdditionalLocations: false,
      streetOne: '',
      cityOne: '',
      stateOne: '',
      zipCodeOne: '',
      phoneOne: '',
      faxOne: '',

      streetTwo: '',
      cityTwo: '',
      stateTwo: '',
      zipCodeTwo: '',
      phoneTwo: '',
      faxTwo: '',

      streetThree: '',
      cityThree: '',
      stateThree: '',
      zipCodeThree: '',
      phoneThree: '',
      faxThree: '',

      // 6
      applicantOwnership: null,

      // 7
      dateAgencyEstablished: '',

      ownershipNameOne: '',
      ownershipOne: '',
      ownershipActiveOne: undefined,
      ownershipExperienceOne: '',

      ownershipNameTwo: '',
      ownershipTwo: '',
      ownershipActiveTwo: undefined,
      ownershipExperienceTwo: '',

      ownershipNameThree: '',
      ownershipThree: '',
      ownershipActiveThree: undefined,
      ownershipExperienceThree: '',

      activeOwnerFullTime: 0,
      activeOwnerPartTime: 0,
      activeOwnerLicensed: 0,

      underwritersFullTime: 0,
      underwritersPartTime: 0,
      underwritersLicensed: 0,

      licensedAgentFullTime: 0,
      licensedAgentPartTime: 0,
      licensedAgentLicensed: 0,

      otherFullTime: 0,
      otherPartTime: 0,
      otherLicensed: 0,

      doYouhaveEoCoverage: null,
      expirationDate: null,
      retroactiveDate: null,

      insurerOne: '',
      policyPeriodOne: '',
      limitOne: '',
      deductibleOne: '',
      premiumOne: '',

      insurerTwo: '',
      policyPeriodTwo: '',
      limitTwo: '',
      deductibleTwo: '',
      premiumTwo: '',

      insurerThree: '',
      policyPeriodThree: '',
      limitThree: '',
      deductibleThree: '',
      premiumThree: '',

      // Page 2

      licensedStateOne: '',
      licensedStateTwo: '',
      licensedStateThree: '',
      licensedSince: '',

      hasEoInsuranceDeclined: null,
      hasEoInsuranceDeclinedDetails: '',

      periodOne: 0,
      periodTwo: 0,
      sumOfPeriod: 0,
      sumOfComission: 0,
      periodThree: '',

      estimateCommissionEarnOne: 0,
      estimateCommissionEarnTwo: 0,
      estimateCommissionEarnThree: '',

      estimateCommissionTwoYearsEarnOne: '',
      estimateCommissionTwoYearsEarnTwo: '',
      estimateCommissionTwoYearsEarnThree: '',

      estimateCommissionPaidOne: '',
      estimateCommissionPaidTwo: '',
      estimateCommissionPaidThree: '',

      noCommissionRetainedOne: '',
      noCommissionRetainedTwo: '',
      noCommissionRetainedThree: '',

      specializeInAnyBusiness: null,
      specializeInAnyBusinessDetails: '',

      // Page 3

      personalAuto: 0,
      personalHomeowners: 0,
      personalOther: 0,
      personalExplain: '',

      commercialAuto: 0,
      commercialProperty: 0,
      commercialLiability: 0,
      commercialPackage: 0,
      commercialWorker: 0,
      commercialOther: 0,
      commercialExplain: '',

      kindOfBusinessLife: 0,
      kindOfBusinessHealth: 0,
      kindOfBusinessOther: 0,
      kindOfBusinessExplain: '',

      otherBusinessThanInsurance: null,
      otherBusinessThanInsuranceDetails: '',

      ownOtherFirm: null,
      ownOtherFirmDetails: '',

      past3YearsAgencyNameChanged: null,
      past3YearsAgencyNameChangedDetails: '',

      incomingMailStamped: null,
      howLongMaintainRecords: '',

      maintainBinderLog: null,
      documentAllBusinessConversations: null,
      coverageChangeRequest: null,
      doYouUsePowerOfAttorney: null,
      acknowledgeDisaster: null,

      withdrawnFromAgencyLast3Years: null,
      withdrawnFromAgencyLast3YearsDetails: '',

      haveBindingAuthority: null,
      haveBindingAuthorityDetails: '',

      planToAquireAnotherOrganization: null,
      planToAquireAnotherOrganizationDetails: '',

      changedManagementStructure5Years: null,
      changedManagementStructure5YearsDetails: '',

      carriersProgramInsuranceCompany1 : '',
      carriersProgram1 : '',
      carriersProgramPremium1 : '',
      carriersProgramExp1 : '',

      carriersProgramInsuranceCompany2 : '',
      carriersProgram2 : '',
      carriersProgramPremium2 : '',
      carriersProgramExp2 : '',

      carriersProgramInsuranceCompany3 : '',
      carriersProgram3 : '',
      carriersProgramPremium3 : '',
      carriersProgramExp3 : '',

      carriersProgramInsuranceCompany4 : '',
      carriersProgram4 : '',
      carriersProgramPremium4 : '',
      carriersProgramExp4 : '',

      experienceOfProgramCompany1: '',
      experienceOfProgramName1: '',
      experienceOfProgramLastYearRatio1: '',
      experienceOfProgram2YearRatio1: '',
      experienceOfProgram3YearRatio1: '',

      experienceOfProgramCompany2: '',
      experienceOfProgramName2: '',
      experienceOfProgramLastYearRatio2: '',
      experienceOfProgram2YearRatio2: '',
      experienceOfProgram3YearRatio2: '',

      experienceOfProgramCompany3: '',
      experienceOfProgramName3: '',
      experienceOfProgramLastYearRatio3: '',
      experienceOfProgram2YearRatio3: '',
      experienceOfProgram3YearRatio3: '',

      experienceOfProgramCompany4: '',
      experienceOfProgramName4: '',
      experienceOfProgramLastYearRatio4: '',
      experienceOfProgram2YearRatio4: '',
      experienceOfProgram3YearRatio4: '',

      functionsYouPerformWholesaler: '',

      programTerminatedInFiveYears: null,
      programTerminatedInFiveYearsDetails: '',

      seniorManagementName1: '',
      seniorManagementTitle1: '',
      seniorManagementExp1: '',
      seniorManagementPercentageOwnership1: '',

      seniorManagementName2: '',
      seniorManagementTitle2: '',
      seniorManagementExp2: '',
      seniorManagementPercentageOwnership2: '',

      seniorManagementName3: '',
      seniorManagementTitle3: '',
      seniorManagementExp3: '',
      seniorManagementPercentageOwnership3: '',

      seniorManagementName4: '',
      seniorManagementTitle4: '',
      seniorManagementExp4: '',
      seniorManagementPercentageOwnership4: '',

      applicantLicensedInJurisdictions: null,
      applicantLicensedInJurisdictionsDetails: '',

      insuranceOperationsNumberOfPolicies: '',
      insuranceOperationsNumberOfContracted: '',
      insuranceOperationsAgentBindingAuthority: null,
      insuranceOperationsAgentBindingAuthorityDetails: '',

      reinsurersAudit: '',
      lastAuditCompleted: '',

      assumeRiskOnProgram: null,
      assumeRiskOnProgramDetails: '',

      haveElectronicPolicySystem: null,
      haveElectronicPolicySystemDetails: '',

      haveAuthorityToHandleClaims: null,
      haveAuthorityToHandleClaimsDetails: '',

      haveIndemnificationCoverage: null,

      purchaseReinsuranceBehalfCarriers: null,
      purchaseReinsuranceBehalfCarriersDetails: '',

      companiesRisk25Percent: null,
      companiesRisk25PercentDetails: '',

      producersMaintainInsurance: null,
      producersMaintainInsuranceDetails: '',

      subjectToDisciplinaryAction: null,
      subjectToDisciplinaryActionDetails: '',

      claimsAgainstApplicantLast5Years: null,
      claimsAgainstApplicantLast5YearsDetails: '',

      claimsAgainstApplicantAfterInquiry: null,
      claimsAgainstApplicantAfterInquiryDetails: '',

      effectiveDate: null,
      desiredCoverage: [],
      desiredCoverageCustomLimit: '',
      deductible: '5000',
      deductibleCustomLimit: '',
      // Page 5
      appraiserEsignatureDatetime: moment().format('YYYY-MM-DD'),
      nameForFraudWarning: null,
      titleForFraudWarning: null,
      clientSignature: '',

      emailPolicy: true,
      applicantRequestFrom: '',
      nklTitle: '',
      nklName: '',
      nklSignature: '',
    },
    effectiveDateValid: false,
    retroactiveDateValid: false,
    pageOneIsValid: false,
    pageTwoIsValid: false,
    pageThreeIsValid: false,
    pageFourIsValid: false,
    pageFiveIsValid: false,
    pageSixIsValid: false,
    pageSevenIsValid: false,
    errorMsg: null,
  },
  actions: {
    createMgaApplication({ state }) {
      state.errorMsg = null;
      Functions.xapi()
          .post('api/ibdpro-mga-application/', {
            ...Functions.snakeCaseKeys(state.mgaApplication),
            effective_date: moment(state.mgaApplication.effectiveDate).format('YYYY-MM-DD'),
            retroactive_date: moment(state.mgaApplication.retroactiveDate).format('YYYY-MM-DD'),
          })
          .then((res) => {
            // eslint-disable-next-line no-unused-vars
            let page = '';
            page = 'ibdpro-mga-application-representation';
            router.push({
              name: page,
            });
          })
          .catch((error) => {
            const firstErrorMsg = (res) => {
              if (!Array.isArray(res)) {
                if (typeof res === 'object') {
                  firstErrorMsg(res[Object.keys(res)[0]]);
                } else {
                  return 'Server Error';
                }
              } else {
                state.errorMsg = res[0];
              }
            };

            firstErrorMsg(error.response.data);
          });
    },
    createCustomer({ state }) {
      state.errorMsg = null;
      Functions.xapi()
          .post('api/customer/create-customer/', {
            ...Functions.snakeCaseKeys({
              ...state.mgaApplication.customer, // disable this checkbox
            }),
            // desired_coverage: COVERAGES.filter(coverage => state.quote.desiredCoverage.find(ele => ele === coverage)),
          })
          .then((res) => {
            state.mgaApplication.customer.actContactId = Functions.convertObjectKeyToCamelCase(res.data).actContactId;
            Functions.trackWhatConvertsLead(state.mgaApplication.customer);
            router.push({
              name: 'ibdpro-mga-application-2',
            });
          })
          .catch((error) => {
            const firstErrorMsg = (res) => {
              if (!Array.isArray(res)) {
                if (typeof res === 'object') {
                  firstErrorMsg(res[Object.keys(res)[0]]);
                } else {
                  return 'Server Error';
                }
              } else {
                state.errorMsg = res[0];
              }
            };

            firstErrorMsg(error.response.data);
          });
    },
  },
  getters: {
    totalFullTime: state => (
        Number(state.mgaApplication.activeOwnerFullTime)
        + Number(state.mgaApplication.underwritersFullTime)
        + Number(state.mgaApplication.licensedAgentFullTime)
        + Number(state.mgaApplication.otherFullTime)
    ),
    totalPartTime: state => (
        Number(state.mgaApplication.activeOwnerPartTime)
        + Number(state.mgaApplication.underwritersPartTime)
        + Number(state.mgaApplication.licensedAgentPartTime)
        + Number(state.mgaApplication.otherPartTime)
    ),
    totalLicensed: state => (
        Number(state.mgaApplication.activeOwnerLicensed)
        + Number(state.mgaApplication.underwritersLicensed)
        + Number(state.mgaApplication.licensedAgentLicensed)
        + Number(state.mgaApplication.otherLicensed)
    ),
  },
};

export default new Vuex.Store({
  state: {
    hostname: '',
    siteName: '',
  },
  mutations: {
    setHostname(state, hostname) {
      state.hostname = hostname;
    },
    setSiteName(state, siteName) {
      state.siteName = siteName;
    },
  },
  actions: {
    initializeConfig({ commit }) {
      const hostname = window.location.hostname;  // Get the current hostname

      // Set configuration based on the hostname
      if (hostname === 'www.liabilityinsuranceapps.com') {
        commit('setSiteName', 'Liability Insurance Apps');
      } else {
        commit('setSiteName', 'OREP Portal');
      }
      // Commit the hostname
      commit('setHostname', hostname);
    },
  },
  getters: {
    getHostname(state) {
      return state.hostname;
    },
    getSiteName(state) {
      return state.siteName;
    },
  },

  modules: {
    customerDetail: customerModule,
    homeInspector: homeInspectorModule,
    individualAppraiser: individualAppraiserModule,
    groupAppraiser: groupAppraiserModule,
    standardApplication: standardApplicationModule,
    rxApplication: rxApplicationModule,
    axApplication: axApplicationModule,
    ipfs: ipfsModule,
    piApplication: piApplicationModule,
    sipApplication: sipApplicationModule,
    ppiApplication: ppiApplicationModule,
    quickQuote: quickQuoteModule,
    rcApplication: rcApplicationModule,
    insuranceAgentApplication: insuranceAgentApplicationModule,
    mgaApplication: mgaApplicationModule,
  },
});
